(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1306],{

/***/ 316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CourseCard */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_icons_ai__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8193);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63750);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86893);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51649);
/* harmony import */ var _course_card_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81648);
/* harmony import */ var _course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);

var _excluded = ["link", "name", "level", "exams", "session", "duration", "month", "year", "amountFrom", "amountTo", "countryCurrency", "intakes", "isAlignRow"];









var CourseCard = function CourseCard(_ref) {
  var link = _ref.link,
      name = _ref.name,
      level = _ref.level,
      exams = _ref.exams,
      session = _ref.session,
      duration = _ref.duration,
      month = _ref.month,
      year = _ref.year,
      amountFrom = _ref.amountFrom,
      amountTo = _ref.amountTo,
      countryCurrency = _ref.countryCurrency,
      intakes = _ref.intakes,
      isAlignRow = _ref.isAlignRow,
      porps = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var intakeArray = (intakes === null || intakes === void 0 ? void 0 : intakes.length) > 0 ? intakes === null || intakes === void 0 ? void 0 : intakes.sort(function (a, b) {
    return a.intakeYear - b.intakeYear;
  }) : [];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card), " ").concat(isAlignRow ? (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().align_row) : ""),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      legacyBehavior: true,
      href: link,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("h3", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_title),
          children: name
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("ul", {
      className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_info_lists),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_5__/* .IoMdSchool */ .TVA, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "Course Level"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: level
          })]
        })]
      }), duration && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_6__/* .AiOutlineClockCircle */ .cjn, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "Course Duration"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
            children: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .calcDuration */ .LF)(duration)
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_7__/* .BsCashStack */ .zzp, {
          style: {
            fontSize: "15px"
          },
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "1st Year Tution Fees"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
            children: [countryCurrency, " ", amountFrom ? (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .numFormatter */ .tV)(amountFrom) : "", amountTo && amountTo != 0 && " - " + (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .numFormatter */ .tV)(amountTo)]
          })]
        })]
      }), intakes && (intakes === null || intakes === void 0 ? void 0 : intakes.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_ai__WEBPACK_IMPORTED_MODULE_6__/* .AiOutlineCalendar */ .xHR, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: "Intake"
            }), (intakeArray === null || intakeArray === void 0 ? void 0 : intakeArray.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake), " relative"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_num),
                children: ["+", intakeArray.length - 1]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "uni-tooltip top",
                children: intakeArray.slice(1).map(function (intk, i) {
                  if (intk !== null && intk !== void 0 && intk.admissionSessionName && (intk === null || intk === void 0 ? void 0 : intk.admissionSessionName) != "") {
                    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                      children: [intk === null || intk === void 0 ? void 0 : intk.admissionSessionName, ": ", intk === null || intk === void 0 ? void 0 : intk.intakeMonth, " ", intk === null || intk === void 0 ? void 0 : intk.intakeYear, " "]
                    }, i);
                  }
                })
              })]
            })]
          }), intakeArray.slice(0, 1).map(function (intk, i) {
            if (intk !== null && intk !== void 0 && intk.admissionSessionName && (intk === null || intk === void 0 ? void 0 : intk.admissionSessionName) != "") {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
                children: [intk === null || intk === void 0 ? void 0 : intk.admissionSessionName, ": ", intk === null || intk === void 0 ? void 0 : intk.intakeMonth, " ", intk === null || intk === void 0 ? void 0 : intk.intakeYear, " "]
              }, i);
            }
          })]
        })]
      }), exams && (exams === null || exams === void 0 ? void 0 : exams.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_8__/* .FiFileText */ .NOg, {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
            className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              children: "Eligibility"
            }), (exams === null || exams === void 0 ? void 0 : exams.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake), " relative"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
                className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().more_intake_num),
                children: ["+", exams.length - 1]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "uni-tooltip top",
                children: exams.slice(1).map(function (exm, i) {
                  var _exm$exam;

                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
                    children: [exm === null || exm === void 0 ? void 0 : (_exm$exam = exm.exam) === null || _exm$exam === void 0 ? void 0 : _exm$exam.examName, ": ", exm === null || exm === void 0 ? void 0 : exm.score, " "]
                  }, i);
                })
              })]
            })]
          }), exams.slice(0, 1).map(function (exm, i) {
            var _exm$exam2;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
              className: (_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().card_text_last),
              children: [exm === null || exm === void 0 ? void 0 : (_exm$exam2 = exm.exam) === null || _exm$exam2 === void 0 ? void 0 : _exm$exam2.examName, ": ", exm === null || exm === void 0 ? void 0 : exm.score, " "]
            }, i);
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      legacyBehavior: true,
      href: link ? link : "#",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        className: "".concat((_course_card_module_scss__WEBPACK_IMPORTED_MODULE_4___default().course_card_link), " btn btn-primary"),
        children: "View Details"
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCard);

/***/ }),

/***/ 19803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScholarshipCard */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21003);
/* harmony import */ var _scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63750);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80008);
/* harmony import */ var moment_timezone__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);

var _excluded = ["name", "amount", "deadline", "link", "badge", "countryCurrencySymbol"];







var ScholarshipCard = function ScholarshipCard(_ref) {
  var name = _ref.name,
      amount = _ref.amount,
      deadline = _ref.deadline,
      link = _ref.link,
      badge = _ref.badge,
      countryCurrencySymbol = _ref.countryCurrencySymbol,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
    className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card),
    children: [badge && badge.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("ul", {
      className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_tags),
      children: badge.map(function (item, i) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("li", {
          className: i % 2 === 0 ? (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().exclusive) : (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().applicant),
          children: item
        }, i);
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      legacyBehavior: true,
      href: link || "#",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h3", {
          className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_title),
          children: name
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("ul", {
      className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_info_lists),
      children: [amount && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_6__/* .BsCashStack */ .zzp, {
          className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            children: "Value"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("span", {
            children: [countryCurrencySymbol, parseInt(amount)]
          })]
        })]
      }), deadline && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("li", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_6__/* .BsCalendar */ .Mvo, {
          className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_icon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
          className: (_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_text),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            children: "Deadline"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            children: moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(deadline).format("Do MMMM, YYYY")
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      legacyBehavior: true,
      href: link || "#",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", {
        className: "".concat((_scholarship_card_module_scss__WEBPACK_IMPORTED_MODULE_5___default().scp_card_link), " btn btn-primary btn-md"),
        children: "More Details"
      })
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (ScholarshipCard);

/***/ }),

/***/ 97623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yQ": function() { return /* reexport */ UniBrief; },
  "gK": function() { return /* reexport */ UniHeroWithVideo; },
  "pA": function() { return /* reexport */ UniLinks; },
  "q6": function() { return /* reexport */ uni_profile_banner/* UniProfileBanner */.q; },
  "au": function() { return /* reexport */ UniProfileWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./_modules/study/common/play_btn_with_ripple/index.jsx
var play_btn_with_ripple = __webpack_require__(42422);
// EXTERNAL MODULE: ./_modules/study/university/uni_hero_with_video.module.scss
var uni_hero_with_video_module = __webpack_require__(47656);
var uni_hero_with_video_module_default = /*#__PURE__*/__webpack_require__.n(uni_hero_with_video_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/university/uni_hero_with_video.jsx



var ModalVideo = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6635).then(__webpack_require__.bind(__webpack_require__, 61239));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61239)];
    }
  }
});





var UniHeroWithVideo = function UniHeroWithVideo(_ref) {
  var uniProfileData = _ref.uniProfileData;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: (uni_hero_with_video_module_default()).uni_hero,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_hero_with_video_module_default()).video_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_hero_with_video_module_default()).overlay
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          layout: "responsive",
          width: 840,
          height: 450,
          blurDataURL: (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
          placeholder: "blur",
          className: (uni_hero_with_video_module_default()).featured_image,
          src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.coverphotoLogoSrc) || (0,helpers/* getAssets */.Vh)("assets/images/image_placeholder_big.webp"),
          alt: "Video Background"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(play_btn_with_ripple/* default */.Z, {
          onClick: function onClick() {
            return setOpen(true);
          }
        })]
      })
    }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.videoType) === "upload" && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "custom",
      autoplay: true,
      isOpen: isOpen,
      url: uniProfileData ? uniProfileData.videoSrc : "",
      onClose: function onClose() {
        return setOpen(false);
      }
    }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.videoType) === "embeded" && /*#__PURE__*/(0,jsx_runtime.jsx)(ModalVideo, {
      channel: "youtube",
      autoplay: true,
      isOpen: isOpen,
      videoId: uniProfileData ? uniProfileData.embedCode : "",
      onClose: function onClose() {
        return setOpen(false);
      }
    })]
  });
};
/* harmony default export */ var uni_hero_with_video = ((/* unused pure expression or super */ null && (UniHeroWithVideo)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Rating/Rating.js + 3 modules
var Rating = __webpack_require__(90926);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(58735);
// EXTERNAL MODULE: ./_unisearch/common/index.js + 9 modules
var common = __webpack_require__(74155);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_recoil/_actions/index.js + 5 modules
var _actions = __webpack_require__(8612);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var index_esm = __webpack_require__(47516);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-icons/ri/index.esm.js
var ri_index_esm = __webpack_require__(79352);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./_modules/study/university/uni_brief.module.scss
var uni_brief_module = __webpack_require__(47022);
var uni_brief_module_default = /*#__PURE__*/__webpack_require__.n(uni_brief_module);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/guest_form_review.jsx
var guest_form_review = __webpack_require__(17171);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/register_form_review.jsx
var register_form_review = __webpack_require__(25702);
;// CONCATENATED MODULE: ./_modules/study/university/uni_brief.jsx





















var FavoriteAction = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(726)]).then(__webpack_require__.bind(__webpack_require__, 25494));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(25494)];
    }
  }
});
var CompareAction = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(3609), __webpack_require__.e(180)]).then(__webpack_require__.bind(__webpack_require__, 76723));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76723)];
    }
  }
});

var ReviewOption = function ReviewOption(_ref) {
  var value = _ref.value,
      uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      existingComment = _ref.existingComment,
      onEdit = _ref.onEdit,
      getComment = _ref.getComment;

  switch (value) {
    case 0:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(guest_form_review/* default */.Z, {
        getData: getData,
        setModal: setModal,
        uniProfileData: uniProfileData
      });

    case 1:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(register_form_review/* default */.Z, {
        setModal: setModal,
        uniProfileData: uniProfileData,
        getData: getData,
        onEdit: onEdit,
        existingComment: existingComment,
        getComment: getComment
      });
  }
};

var UniBrief = function UniBrief(_ref2) {
  var _uniProfileData$docum, _uniProfileData$docum2;

  var uniProfileData = _ref2.uniProfileData,
      customClasses = _ref2.customClasses;
  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(false),
      modal = _useState[0],
      setModal = _useState[1];

  var _useState2 = (0,react.useState)(0),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      existingComment = _useState3[0],
      setExistingComment = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      onEdit = _useState4[0],
      setOnEdit = _useState4[1];

  var systemActions = (0,_actions/* useSystemActions */.x3)(); // get existing comment

  var getComment = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.get */.Z.get("/public/university-review/check/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug)).then(function (res) {
                if (!res.error && res.data) {
                  var data = res.data;
                  setExistingComment(data);
                  setOnEdit(true);
                } else {
                  setExistingComment({});
                  setOnEdit(false);
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getComment() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universitySlug && profileInfo && modal) {
      getComment();
    }
  }, [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug, profileInfo, modal]);
  (0,react.useEffect)(function () {
    if (profileInfo) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [profileInfo]);

  var getData = function getData() {};

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "".concat((uni_brief_module_default()).section_uni_brief, " ").concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses === null || customClasses === void 0 ? void 0 : customClasses.root : ""),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_brief_module_default()).brief_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_brief_module_default()).brief_left_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (uni_brief_module_default()).uni_logo_wrapper,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.logosrc) || (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/logo-placeholder.png"),
              alt: "University Logo"
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).uni_brief_info,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
              children: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityName
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaUniversity */.Q7H, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universityType ? (0,helpers/* upperFirstLetter */.cK)(uniProfileData.universityType) : "", " ", "University, Estd ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.estd]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaMapMarkerAlt */.Nh4, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.cityName, ", ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.stateName]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ri_index_esm/* RiBook2Fill */.XbY, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalCourse, " ", (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalCourse) > 1 ? "Courses" : "Course"]
                })]
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_brief_module_default()).brief_right_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).rating_wrapper,
            children: [(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalRating) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_brief_module_default()).info_rating_number,
              children: [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating, " (", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.totalRating, ")"]
            }), (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating) && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_brief_module_default()).info_rating_stars,
              onClick: function onClick() {
                setModal(true);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Rating/* default */.Z, {
                name: "rating-read",
                value: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating) && parseInt(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.finalRating),
                readOnly: true
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
            rel: "nofollow",
            className: (uni_brief_module_default()).uni_web_link,
            href: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.website,
            target: "_blank",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: "International student website"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* BiLinkExternal */.rpH, {})]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).compare_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavoriteAction, {
              referance: "university",
              referanceId: parseInt(uniProfileData.universityId),
              is_favorite: (0,helpers/* isUniFavorite */.bt)(profileInfo, uniProfileData.universityId)
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompareAction, {
              referance: "university",
              referanceId: parseInt(uniProfileData.universityId),
              is_compared: (0,helpers/* isUniCompare */.j1)(profileInfo, uniProfileData.universityId)
            }), uniProfileData && (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.documentInfo) && /*#__PURE__*/(0,jsx_runtime.jsx)(common/* DownloadGuide */.E6, {
              customClasses: {
                root: "btn-bg"
              },
              fileSrc: uniProfileData === null || uniProfileData === void 0 ? void 0 : (_uniProfileData$docum = uniProfileData.documentInfo) === null || _uniProfileData$docum === void 0 ? void 0 : _uniProfileData$docum.documentSrc,
              documentId: uniProfileData === null || uniProfileData === void 0 ? void 0 : (_uniProfileData$docum2 = uniProfileData.documentInfo) === null || _uniProfileData$docum2 === void 0 ? void 0 : _uniProfileData$docum2.documentId,
              documentType: "prospectus",
              universityId: parseInt(uniProfileData.universityId)
            })]
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      open: modal,
      onClose: function onClose() {
        setModal(false);
      },
      closeAfterTransition: true,
      BackdropComponent: Backdrop/* default */.Z,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "modal md",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "modal_head ".concat((uni_brief_module_default()).modal_header),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: "".concat((uni_brief_module_default()).title, " modal_title")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "cross_icon ".concat((uni_brief_module_default()).cross_action),
            onClick: function onClick() {
              setModal(false);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiX */.q5L, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "".concat((uni_brief_module_default()).modal_body, " modal_body"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: (uni_brief_module_default()).modal_title,
            children: "Write a Review"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (uni_brief_module_default()).modal_description,
            children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dignissim odio dui, felis ultricies. Scelerisque quam tristique faucibus cras. Malesuada lobortis habitasse et enim vitae lectus tellus. Et volutpat hendrerit iaculis non in adipiscing tincidunt ut."
          }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_brief_module_default()).action_btn,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                setValue(0);
              },
              className: value === 0 && (uni_brief_module_default()).active_btn,
              children: "Guest User"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
              onClick: function onClick() {
                setValue(1);
              },
              className: value === 1 && (uni_brief_module_default()).active_btn,
              children: "Register User"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewOption, {
            setModal: setModal,
            uniProfileData: uniProfileData,
            value: value,
            getData: getData,
            existingComment: existingComment,
            onEdit: onEdit,
            getComment: getComment
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ var uni_brief = ((/* unused pure expression or super */ null && (UniBrief)));
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./_modules/study/university/uni_links.module.scss
var uni_links_module = __webpack_require__(13777);
var uni_links_module_default = /*#__PURE__*/__webpack_require__.n(uni_links_module);
// EXTERNAL MODULE: ./node_modules/country-data/index.js
var country_data = __webpack_require__(3023);
;// CONCATENATED MODULE: ./_modules/study/university/uni_links.jsx













var UniLinks = function UniLinks(props) {
  var _props$uniProfileData, _systemInfo$visitor_c, _systemInfo$visitor_c2, _props$uniProfileData2, _systemInfo$visitor_c3, _systemInfo$visitor_c4, _systemInfo$visitor_c5, _props$uniProfileData3, _props$uniProfileData4, _props$uniProfileData5, _props$uniProfileData6;

  var router = (0,next_router.useRouter)();
  var asPath = router.asPath,
      query = router.query;
  var systemActions = (0,_actions/* useSystemActions */.x3)();
  var systemInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* systemAtom */.K2);

  var _useState = (0,react.useState)({}),
      menuStatus = _useState[0],
      setMenuStatus = _useState[1];

  var coursesLevelPageLink;
  var overviewPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name);
  var admissionFaqPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/admission-faq");
  var rankingPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/ranking");
  var coursesPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses");
  query.course_level ? coursesLevelPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses/").concat(query.course_level) : "";
  var searchCoursePageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/search-courses");
  var scholarshipsPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships");
  var scholarshipDetailsPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships/").concat(query.scholarship_slug);
  var blogPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/blog");
  var staffPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/staff");
  var eventFairPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/event-fair");
  var galleryPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/gallery");
  var reviewPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/reviews");
  var contactPageLink = "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/contact");

  var getIpInof = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var default_country, _countries$default_co, _countries$default_co2, _countries$default_co4, _countries$default_co5, _countries$default_co3;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              default_country = localStorage.getItem("default_country");

              if (default_country && default_country != "") {
                //set visitor default courrencies
                if ((!(systemInfo !== null && systemInfo !== void 0 && systemInfo.currency) || (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency) == "") && (_countries$default_co = country_data/* countries */.hW[default_country.toUpperCase()]) !== null && _countries$default_co !== void 0 && _countries$default_co.currencies[0] && ((_countries$default_co2 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co2 === void 0 ? void 0 : _countries$default_co2.currencies[0]) != "") {
                  systemActions.setSystemCurrency((_countries$default_co3 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co3 === void 0 ? void 0 : _countries$default_co3.currencies[0]);
                } //set visitor countries


                if ((!(systemInfo !== null && systemInfo !== void 0 && systemInfo.visitor_country) || Object.keys(systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.visitor_country).length === 0) && (_countries$default_co4 = country_data/* countries */.hW[default_country.toUpperCase()]) !== null && _countries$default_co4 !== void 0 && _countries$default_co4.name && ((_countries$default_co5 = country_data/* countries */.hW[default_country.toUpperCase()]) === null || _countries$default_co5 === void 0 ? void 0 : _countries$default_co5.name) != "") {
                  systemActions.setVisitorCountry(country_data/* countries */.hW[default_country.toUpperCase()]);
                }
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getIpInof() {
      return _ref.apply(this, arguments);
    };
  }(); //get IP Info


  (0,react.useEffect)(function () {
    getIpInof();
  }, []);
  (0,react.useEffect)(function () {
    function getMenuStatius() {
      return _getMenuStatius.apply(this, arguments);
    }

    function _getMenuStatius() {
      _getMenuStatius = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return api/* default.get */.Z.get("/public/university/menu-status/".concat(query.university_name)).then(function (resp) {
                  if (!resp.error && resp.data) {
                    setMenuStatus(resp.data);
                  } else {
                    setMenuStatus({});
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getMenuStatius.apply(this, arguments);
    }

    getMenuStatius();
  }, [query.university_name]); // set system currency

  var setSystemCurrency = function setSystemCurrency(e) {
    systemActions.setSystemCurrency(e.target.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: (uni_links_module_default()).section_links,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (uni_links_module_default()).links_wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_links_module_default()).links_container,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: (uni_links_module_default()).link_lists,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: overviewPageLink,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === overviewPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Overview"
                })
              })
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.faq && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.faq) === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(admissionFaqPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === admissionFaqPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Admission FAQ"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.ranking && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.ranking) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(rankingPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === rankingPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Rankings"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.course && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.course) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(coursesPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath.split("?")[0] == coursesPageLink || coursesLevelPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Courses"
                })
              })
            }) : "", query.course_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(coursesPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(query.course_slug ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Course Details"
                })
              })
            }), asPath.includes("search-courses") && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Search Courses"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.sholarship && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.sholarship) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(scholarshipsPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === scholarshipsPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Scholarships"
                })
              })
            }) : "", query.scholarship_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Scholarship Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.blog && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.blog) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(blogPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === blogPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Blog"
                })
              })
            }) : "", query.uni_blog_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Blog Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.staff && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.staff) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(staffPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === staffPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Staff"
                })
              })
            }) : "", query.staff_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Staff Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.eventFair && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.eventFair) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(eventFairPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === eventFairPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Event/Fair"
                })
              })
            }) : "", menuStatus !== null && menuStatus !== void 0 && menuStatus.gallery && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.gallery) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(galleryPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === galleryPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Gallery"
                })
              })
            }) : "", query.slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "".concat((uni_links_module_default()).link_list_item, " ").concat((uni_links_module_default()).active),
              children: "Gallery Details"
            }), menuStatus !== null && menuStatus !== void 0 && menuStatus.review && (menuStatus === null || menuStatus === void 0 ? void 0 : menuStatus.review) == 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(reviewPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === reviewPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Reviews"
                })
              })
            }) : "", /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                legacyBehavior: true,
                href: "".concat(contactPageLink),
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "".concat((uni_links_module_default()).link_list_item, " ").concat(asPath === contactPageLink ? "".concat((uni_links_module_default()).active) : ""),
                  children: "Contact"
                })
              })
            }), query.course_slug && /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("select", {
                name: "currencyCode",
                id: "currencyCode",
                className: (uni_links_module_default()).currencyChanger,
                onChange: setSystemCurrency,
                disabled: systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.loading,
                value: systemInfo !== null && systemInfo !== void 0 && systemInfo.currency && (systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency) != "" ? systemInfo === null || systemInfo === void 0 ? void 0 : systemInfo.currency : props === null || props === void 0 ? void 0 : (_props$uniProfileData = props.uniProfileData) === null || _props$uniProfileData === void 0 ? void 0 : _props$uniProfileData.countryCurrency,
                children: systemInfo !== null && systemInfo !== void 0 && systemInfo.loading ? /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                  value: "",
                  children: " Loading "
                }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
                  children: [(systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c = systemInfo.visitor_country) === null || _systemInfo$visitor_c === void 0 ? void 0 : _systemInfo$visitor_c.currencies) && (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c2 = systemInfo.visitor_country) === null || _systemInfo$visitor_c2 === void 0 ? void 0 : _systemInfo$visitor_c2.currencies[0].toUpperCase()) != (props === null || props === void 0 ? void 0 : (_props$uniProfileData2 = props.uniProfileData) === null || _props$uniProfileData2 === void 0 ? void 0 : _props$uniProfileData2.countryCurrency.toUpperCase()) && (systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c3 = systemInfo.visitor_country) === null || _systemInfo$visitor_c3 === void 0 ? void 0 : _systemInfo$visitor_c3.currencies[0].toUpperCase()) != "USD" && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c4 = systemInfo.visitor_country) === null || _systemInfo$visitor_c4 === void 0 ? void 0 : _systemInfo$visitor_c4.currencies[0].toUpperCase(),
                    children: systemInfo === null || systemInfo === void 0 ? void 0 : (_systemInfo$visitor_c5 = systemInfo.visitor_country) === null || _systemInfo$visitor_c5 === void 0 ? void 0 : _systemInfo$visitor_c5.currencies[0].toUpperCase()
                  }), (props === null || props === void 0 ? void 0 : (_props$uniProfileData3 = props.uniProfileData) === null || _props$uniProfileData3 === void 0 ? void 0 : _props$uniProfileData3.countryCurrency) && (props === null || props === void 0 ? void 0 : (_props$uniProfileData4 = props.uniProfileData) === null || _props$uniProfileData4 === void 0 ? void 0 : _props$uniProfileData4.countryCurrency) != "USD" && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: props === null || props === void 0 ? void 0 : (_props$uniProfileData5 = props.uniProfileData) === null || _props$uniProfileData5 === void 0 ? void 0 : _props$uniProfileData5.countryCurrency,
                    children: props === null || props === void 0 ? void 0 : (_props$uniProfileData6 = props.uniProfileData) === null || _props$uniProfileData6 === void 0 ? void 0 : _props$uniProfileData6.countryCurrency
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                    value: "USD",
                    children: "USD"
                  })]
                })
              })
            })]
          })
        })
      })
    })
  });
};
/* harmony default export */ var uni_links = ((/* unused pure expression or super */ null && (UniLinks)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_wrapper.module.scss
var uni_profile_wrapper_module = __webpack_require__(98281);
var uni_profile_wrapper_module_default = /*#__PURE__*/__webpack_require__.n(uni_profile_wrapper_module);
// EXTERNAL MODULE: ./_hooks/useWindowDimensions.js
var useWindowDimensions = __webpack_require__(14418);
;// CONCATENATED MODULE: ./_modules/study/university/uni_profile_wrapper.jsx

var _excluded = ["isVideoBanner", "isBanner", "isBreadcrumb", "breadcrumbTitle", "children"];










var UniProfileWrapper = function UniProfileWrapper(_ref) {
  var _ref$isVideoBanner = _ref.isVideoBanner,
      isVideoBanner = _ref$isVideoBanner === void 0 ? true : _ref$isVideoBanner,
      _ref$isBanner = _ref.isBanner,
      isBanner = _ref$isBanner === void 0 ? true : _ref$isBanner,
      _ref$isBreadcrumb = _ref.isBreadcrumb,
      isBreadcrumb = _ref$isBreadcrumb === void 0 ? true : _ref$isBreadcrumb,
      breadcrumbTitle = _ref.breadcrumbTitle,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var uniProfileData = props.uniProfileData;

  var _useWindowDimensions = (0,useWindowDimensions/* default */.Z)(),
      width = _useWindowDimensions.width;

  var router = (0,next_router.useRouter)();
  var query = router.query,
      pathname = router.pathname;
  var targetPathSlug = pathname.split("/")[5];
  var course_slug = query.course_slug;

  var breadCrumbActiveLink = function breadCrumbActiveLink() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "color-orange",
      children: breadcrumbTitle ? breadcrumbTitle : (0,helpers/* generateNavTitle */.He)(targetPathSlug)
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [isBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.videoType && isVideoBanner ? /*#__PURE__*/(0,jsx_runtime.jsx)(UniHeroWithVideo, {
        uniProfileData: uniProfileData
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(uni_profile_banner/* UniProfileBanner */.q, {
        uniProfileData: uniProfileData
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniBrief, {
      uniProfileData: uniProfileData,
      customClasses: {
        root: !isBanner ? (uni_profile_wrapper_module_default()).root : ""
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniLinks, {
      uniProfileData: uniProfileData
    }), (isBanner || width < 992) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (uni_profile_wrapper_module_default()).uni_breacrumbs,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: "Home"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
        href: "/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.countrySlug, "/university"),
        children: ["Universities in ", uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.CountryName]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/study/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.countrySlug, "/university/").concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug),
        children: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityName
      }), targetPathSlug && breadCrumbActiveLink()]
    }), children]
  });
};
/* harmony default export */ var uni_profile_wrapper = ((/* unused pure expression or super */ null && (UniProfileWrapper)));
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_banner.jsx
var uni_profile_banner = __webpack_require__(69805);
;// CONCATENATED MODULE: ./_modules/study/university/index.js






/***/ }),

/***/ 30851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LQ": function() { return /* reexport */ UniOverview; },
  "rW": function() { return /* reexport */ UniOverviewAccomodation; },
  "RH": function() { return /* reexport */ UniOverviewAdmission; },
  "fM": function() { return /* reexport */ UniOverviewCampus; },
  "xA": function() { return /* reexport */ UniOverviewCourses; },
  "vV": function() { return /* reexport */ UniOverviewScholarship; }
});

// UNUSED EXPORTS: UniOverviewAbout, UniOverviewPopularUniversity, UniOverviewRanking, UniProfileBanner, UniProfileLinks, UniProfileUniBox

// EXTERNAL MODULE: ./_modules/study/university/uni_profile_banner.jsx
var uni_profile_banner = __webpack_require__(69805);
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_links.jsx
var uni_profile_links = __webpack_require__(55912);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_about.jsx




var UniOverviewAbout = function UniOverviewAbout() {
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_about,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [/*#__PURE__*/_jsx("div", {
            className: "heading",
            children: /*#__PURE__*/_jsx("h2", {
              children: "Harvard University Overview"
            })
          }), /*#__PURE__*/_jsx("img", {
            src: "/assets/images/uni-profile/harvard-university.jpg",
            alt: "University"
          }), /*#__PURE__*/_jsx("p", {
            children: "Harvard University, established in 1636, is the oldest and one of the most famous institutions in the United States. A statue of John Harvard, College\u2019s first patron, stands in front of University Hall in Harvard Yard and is perhaps the University\u2019s best-known landmark. This Ivy League university carries its legacy from over 375 years not only in the United States but globally as well. Harvard currently has 12 degree-granting Schools in addition to the Radcliffe Institute for Advanced Study. The University has grown from nine students with a single master in the mid-1600s to an enrollment of more than 20,000-degree candidates including undergraduate, graduate, and professional students."
          }), /*#__PURE__*/_jsx("p", {
            children: "With a campus size of 5457 acres, Harvard is based in Massachusetts, Cambridge. Organized around ancient city greens, tree-lined squares, and also the sedgy banks of the Charles River, Cambridge is one among metropolitan Boston\u2019s very important urban centers. Harvard is at the center of Cambridge, giving individuals immediate access to the city\u2019s dense mixture of retailers, restaurants, and diversion. Cambridge is an element of Boston\u2019s comprehensive public transit. With buses, cabs, and a subway stop right in the middle of Harvard sq., you'll simply get anyplace you would like to travel. Downtown Beantown is simply a 12-minute ride from the field."
          }), /*#__PURE__*/_jsx("p", {
            children: "Harvard has a diverse student population from over 50 states and 80 countries and currently more than 36,000 students are studying at Harvard out of which 6,699 are enrolled in Harvard College, 13,120 as graduate and professional students, and 16,193 in Harvard Extension School. Harvard has the oldest academic library in the world consisting of 20.4 million volumes, 180,000 serial titles, an estimated 400 million manuscript items, 10 million photographs, 124 million archived web pages, and 5.4 terabytes of born-digital archives and manuscripts. Approximately 70 percent of the students receive some sort of financial aid at Harvard, and about 60 percent receive need-based scholarships and pay an average of $12,000 per year. Harvard has an alumni base of more than 2.79 lakh in the US and 59,000 spread across 202 countries. It has about 2,400 world-class faculty members and more than 10,400 academic appointments in affiliated teaching hospitals. Harvard has 48 Nobel Laureates, 32 heads of state, 48 Pulitzer Prize winners who have been affiliated as students, faculty, or researchers."
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.table_wrapper,
          children: /*#__PURE__*/_jsx("table", {
            children: /*#__PURE__*/_jsxs("tbody", {
              children: [/*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Total International Students"
                }), /*#__PURE__*/_jsx("td", {
                  children: "9,468"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Size of Campus in acres"
                }), /*#__PURE__*/_jsx("td", {
                  children: "5457"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Male/Female Ratio"
                }), /*#__PURE__*/_jsx("td", {
                  children: "1 : 0.94"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "UG/PG Course Ratio"
                }), /*#__PURE__*/_jsx("td", {
                  children: "1 : 4.56"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Faculty/Student Ratio"
                }), /*#__PURE__*/_jsx("td", {
                  children: "1 : 7.0"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Endowments Value"
                }), /*#__PURE__*/_jsx("td", {
                  children: "USD 37 billion"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "No.of Campuses"
                }), /*#__PURE__*/_jsx("td", {
                  children: "1"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "Yearly Hostel & Meals Expense"
                }), /*#__PURE__*/_jsx("td", {
                  children: "USD 15.5k"
                })]
              }), /*#__PURE__*/_jsxs("tr", {
                children: [/*#__PURE__*/_jsx("td", {
                  children: "International Students Website"
                }), /*#__PURE__*/_jsx("td", {
                  children: "http://www.hio.harvard.edu"
                })]
              })]
            })
          })
        })]
      })
    })
  });
};
/* harmony default export */ var uni_overview_about = ((/* unused pure expression or super */ null && (UniOverviewAbout)));
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_ranking.jsx




var UniOverviewRanking = function UniOverviewRanking(_ref) {
  var ranking = _ref.ranking;
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_ranking,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsx("h2", {
          className: styles.heading,
          children: "Ranking"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.sub_heading,
          children: "University Rankings"
        }), /*#__PURE__*/_jsx("ul", {
          className: styles.rankings,
          children: (ranking === null || ranking === void 0 ? void 0 : ranking.length) > 0 && ranking.filter(function (rank) {
            return rank.type == "University";
          }).map(function (item, i) {
            var _item$ranks;

            return /*#__PURE__*/_jsxs("li", {
              className: styles.ranking,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.number,
                children: "#"
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.rank,
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [item.rankingtype, " "]
                }), /*#__PURE__*/_jsxs("span", {
                  children: ["- ", item.companyName, " "]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.rank,
                  children: ((_item$ranks = item.ranks) === null || _item$ranks === void 0 ? void 0 : _item$ranks.length) > 0 && item.ranks.slice(0, 6).map(function (timeline, i) {
                    return /*#__PURE__*/_jsxs("div", {
                      children: ["#", timeline.rank, " at ", timeline.year]
                    });
                  })
                })]
              })]
            }, item.id);
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.sub_heading,
          children: "Course Rankings"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.course_heading,
          children: "Business Courses"
        }), /*#__PURE__*/_jsx("ul", {
          className: styles.rankings,
          children: (ranking === null || ranking === void 0 ? void 0 : ranking.length) > 0 && ranking.filter(function (rank) {
            return rank.type == "Course";
          }).map(function (item, i) {
            var _item$ranks2;

            return /*#__PURE__*/_jsxs("li", {
              className: styles.ranking,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.number,
                children: "#"
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.rank,
                children: [/*#__PURE__*/_jsxs("span", {
                  children: [item.rankingtype, " "]
                }), /*#__PURE__*/_jsxs("span", {
                  children: ["- ", item.companyName, " "]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.rank,
                  children: ((_item$ranks2 = item.ranks) === null || _item$ranks2 === void 0 ? void 0 : _item$ranks2.length) > 0 && item.ranks.slice(0, 6).map(function (timeline, i) {
                    return /*#__PURE__*/_jsxs("div", {
                      children: ["#", timeline.rank, " at ", timeline.year]
                    });
                  })
                })]
              })]
            }, item.id);
          })
        })]
      })
    })
  });
};
/* harmony default export */ var uni_overview_ranking = ((/* unused pure expression or super */ null && (UniOverviewRanking)));
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid_Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/uni_overview_accomodation.module.scss
var uni_overview_accomodation_module = __webpack_require__(28019);
var uni_overview_accomodation_module_default = /*#__PURE__*/__webpack_require__.n(uni_overview_accomodation_module);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_accomodation.jsx









var UniOverviewAccomodation = function UniOverviewAccomodation(_ref) {
  var universityProfileData = _ref.universityProfileData,
      overviewData = _ref.overviewData;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: (overviewData === null || overviewData === void 0 ? void 0 : overviewData.onCampusAccommodation) && /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (uni_overview_accomodation_module_default()).section_accomodation,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_overview_accomodation_module_default()).title_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Accommodation"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (uni_overview_accomodation_module_default()).short_description,
            children: ["Get a headstart on finding the right student housing on- or off-campus for ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              style: {
                fontWeight: 500
              },
              children: universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName
            }), " ", "through our handy list of options below!"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid_Grid/* default */.ZP, {
          container: true,
          spacing: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 7,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_overview_accomodation_module_default()).acc_heading,
              children: ["On campus accommodation :", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "(Available)"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_overview_accomodation_module_default()).acc_desc_title,
              children: "Description"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((uni_overview_accomodation_module_default()).acc_desc, " from_texteditor_wrapper"),
              children: overviewData !== null && overviewData !== void 0 && overviewData.onCampusAccommodation ? (0,helpers/* htmlParse */.QA)(overviewData.onCampusAccommodation) : ""
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 5,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_overview_accomodation_module_default()).image_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                className: (uni_overview_accomodation_module_default()).image_ornament,
                src: (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/image_ornament.svg")
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                className: (uni_overview_accomodation_module_default()).image_shadow,
                src: (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/image_shadow2.png"),
                alt: "Shadow"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: (0,helpers/* getAssets */.Vh)("assets/images/uni-profile/Accommodation.jpg"),
                alt: "Accommodation"
              })]
            })
          })]
        })]
      })
    })
  });
};
/* harmony default export */ var uni_overview_accomodation = ((/* unused pure expression or super */ null && (UniOverviewAccomodation)));
// EXTERNAL MODULE: ./_modules/study/university/uni_profile_uni_box.jsx
var uni_profile_uni_box = __webpack_require__(65111);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/uni_overview.module.scss
var uni_overview_module = __webpack_require__(1288);
var uni_overview_module_default = /*#__PURE__*/__webpack_require__.n(uni_overview_module);
;// CONCATENATED MODULE: ./_modules/study/university/template_two/tem_two_ranking.jsx




var TemTwoRanking = function TemTwoRanking() {
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_ranking,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsx("h2", {
          className: styles.heading,
          children: "Ranking"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.sub_heading,
          children: "University Rankings"
        }), /*#__PURE__*/_jsxs("ul", {
          className: styles.rankings,
          children: [/*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.sub_heading,
          children: "Course Rankings"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.course_heading,
          children: "Business Courses"
        }), /*#__PURE__*/_jsxs("ul", {
          className: styles.rankings,
          children: [/*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.course_heading,
          children: "Business Courses"
        }), /*#__PURE__*/_jsxs("ul", {
          className: styles.rankings,
          children: [/*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            className: styles.ranking,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.number,
              children: "#1"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.rank,
              children: [/*#__PURE__*/_jsx("span", {
                children: "Universities Rankings "
              }), /*#__PURE__*/_jsx("span", {
                children: "- ARWU (Shanghai Ranking) 2020"
              })]
            })]
          })]
        })]
      })
    })
  });
};
/* harmony default export */ var tem_two_ranking = ((/* unused pure expression or super */ null && (TemTwoRanking)));
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./_modules/study/university/template_two/tem_two_profile_matching.jsx






var TemTwoProfileMatching = function TemTwoProfileMatching() {
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_profile_matching,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.matching_wrapper,
          children: [/*#__PURE__*/_jsx("h4", {
            className: styles.title,
            children: "Profile matching"
          }), /*#__PURE__*/_jsx("p", {
            className: styles.text,
            children: "Want to know your chances of admission in this university?"
          }), /*#__PURE__*/_jsx(Link, {
            legacyBehavior: true,
            href: "/signin",
            children: /*#__PURE__*/_jsx("a", {
              className: "btn btn-secondary btn-bg",
              children: "Check Now"
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.image_wrapper,
          children: /*#__PURE__*/_jsx("img", {
            src: getAssets("assets/images/uni-profile/profile-matching.png"),
            alt: "profile-matching"
          })
        })]
      })
    })
  });
};
/* harmony default export */ var tem_two_profile_matching = ((/* unused pure expression or super */ null && (TemTwoProfileMatching)));
;// CONCATENATED MODULE: ./_modules/study/common/scholarship_box/index.jsx








var scholarship_box_ScholarshipBox = function ScholarshipBox(_ref) {
  var title = _ref.title,
      courseLevel = _ref.courseLevel,
      specialization = _ref.specialization,
      value = _ref.value,
      deadline = _ref.deadline,
      externalLink = _ref.externalLink,
      eligibility = _ref.eligibility;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.scholarship_box,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.top,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.title,
        children: title || "title"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.type,
        children: [/*#__PURE__*/_jsx(IoDiamondOutline, {}), /*#__PURE__*/_jsx("span", {
          children: courseLevel || ""
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.applicant,
        children: [/*#__PURE__*/_jsx(MdSchool, {}), /*#__PURE__*/_jsx("span", {
          children: specialization || ""
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.middle,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.value_and_deadline,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.heading,
          children: "Value"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.wrapper,
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FaRegMoneyBillAlt, {})
          }), /*#__PURE__*/_jsx("span", {
            children: value || ""
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.value_and_deadline,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.heading,
          children: "Deadline"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.wrapper,
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(AiOutlineCalendar, {})
          }), /*#__PURE__*/_jsx("span", {
            children: (deadline === null || deadline === void 0 ? void 0 : deadline.substring(0, 10)) || ""
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.value_and_deadline,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.heading,
          children: "Eligibility"
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.wrapper,
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(AiOutlineCalendar, {})
          }), /*#__PURE__*/_jsx("span", {
            children: eligibility || ""
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.bottom,
      children: /*#__PURE__*/_jsx("a", {
        href: externalLink || "#",
        className: "btn btn-secondary",
        target: "_blank",
        children: "Apply Now"
      })
    })]
  });
};

/* harmony default export */ var scholarship_box = ((/* unused pure expression or super */ null && (scholarship_box_ScholarshipBox)));
// EXTERNAL MODULE: ./_unisearch/helpers/utils.js
var utils = __webpack_require__(90705);
;// CONCATENATED MODULE: ./_modules/study/university/template_two/tem_two_scholarships.jsx






var TemTwoScholarships = function TemTwoScholarships(_ref) {
  var universityData = _ref.universityData,
      university_name = _ref.university_name,
      pageData = _ref.pageData;
  var scholarship = universityData.scholarship;
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_cholarships,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsx("h2", {
          children: "International Students scholarships"
        }), /*#__PURE__*/_jsx("div", {
          className: "from_texteditor_wrapper",
          dangerouslySetInnerHTML: createMarkup(pageData === null || pageData === void 0 ? void 0 : pageData.scholarshipHighlight)
        }), /*#__PURE__*/_jsx("h4", {
          children: "Popular scholarships"
        }), /*#__PURE__*/_jsx("div", {
          className: styles.scholarship_box_wrapper,
          children: scholarship.length < 0 && (scholarship === null || scholarship === void 0 ? void 0 : scholarship.slice(0, 4).map(function (data, i) {
            var _data$courseLevel, _data$specialization;

            return /*#__PURE__*/_jsx(ScholarshipBox, {
              title: data.name,
              courseLevel: (_data$courseLevel = data.courseLevel) === null || _data$courseLevel === void 0 ? void 0 : _data$courseLevel.levelName,
              specialization: (_data$specialization = data.specialization) === null || _data$specialization === void 0 ? void 0 : _data$specialization.name,
              value: data.value,
              deadline: data.deadline,
              eligibility: data.eligibility,
              externalLink: data.externalLink
            }, i);
          }))
        })]
      })
    })
  });
};
/* harmony default export */ var tem_two_scholarships = ((/* unused pure expression or super */ null && (TemTwoScholarships)));
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(73873);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(41548);
;// CONCATENATED MODULE: ./_modules/study/university/template_two/tem_two_image_gallery.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var TemtwoImageGallery = function TemtwoImageGallery(_ref) {
  var data = _ref.data;

  var _useState = useState(null),
      nav1 = _useState[0],
      setNav1 = _useState[1];

  var _useState2 = useState(null),
      nav2 = _useState2[0],
      setNav2 = _useState2[1];

  var _useState3 = useState(null),
      slider1 = _useState3[0],
      setSlider1 = _useState3[1];

  var _useState4 = useState(null),
      slider2 = _useState4[0],
      setSlider2 = _useState4[1];

  var imgNum;

  if ((data === null || data === void 0 ? void 0 : data.length) <= 5) {
    imgNum = data === null || data === void 0 ? void 0 : data.length;
  } else {
    imgNum = 6;
  }

  useEffect(function () {
    setNav1(slider1);
    setNav2(slider2);
  });
  var settingsMain = {
    asNavFor: ".slider-nav",
    arrow: true,
    centerMode: true,
    infinite: true,
    centerPadding: "200px 0px",
    slidesToShow: 1,
    speed: 500
  };
  var settingsThumbs = {
    slidesToShow: imgNum,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    swipeToSlide: true
  };
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_image_gallery,
    children: /*#__PURE__*/_jsxs("div", {
      className: "uni_overview_gallery_wrapper",
      children: [/*#__PURE__*/_jsx("div", {
        className: "uni_overview_gallery_slider",
        children: data && data.length > 0 && /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settingsMain), {}, {
          asNavFor: nav2,
          ref: function ref(slider) {
            return setSlider1(slider);
          },
          children: data.filter(function (item) {
            return item.src !== null;
          }).map(function (slide, index) {
            return /*#__PURE__*/_jsx("img", {
              src: slide.src,
              alt: slide === null || slide === void 0 ? void 0 : slide.alt
            }, index);
          })
        }))
      }), data && data.length > 0 && /*#__PURE__*/_jsx("div", {
        className: "uni_overview_gallery_thumbnails",
        children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settingsThumbs), {}, {
          asNavFor: nav1,
          ref: function ref(slider) {
            return setSlider2(slider);
          },
          children: data.filter(function (item) {
            return item.src !== null;
          }).map(function (slide, index) {
            return /*#__PURE__*/_jsx("img", {
              className: styles.slick_slide_image2,
              src: slide === null || slide === void 0 ? void 0 : slide.src,
              alt: slide === null || slide === void 0 ? void 0 : slide.alt
            }, index);
          })
        }))
      })]
    })
  });
};
/* harmony default export */ var tem_two_image_gallery = ((/* unused pure expression or super */ null && (TemtwoImageGallery)));
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 20 modules
var makeStyles = __webpack_require__(6005);
;// CONCATENATED MODULE: ./_modules/study/common/uni_campus/index.jsx






var uni_campus_UniCampus = function UniCampus(_ref) {
  var email = _ref.email,
      phone = _ref.phone,
      address = _ref.address,
      website = _ref.website,
      map = _ref.map;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.campus_info,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.left,
      children: /*#__PURE__*/_jsx("div", {
        className: "from_texteditor_wrapper",
        children: /*#__PURE__*/_jsx("table", {
          children: /*#__PURE__*/_jsxs("tbody", {
            children: [/*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: "Email"
              }), /*#__PURE__*/_jsx("td", {
                children: email !== null && email !== void 0 ? email : ""
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: "Phone"
              }), /*#__PURE__*/_jsx("td", {
                children: phone !== null && phone !== void 0 ? phone : ""
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: "Address"
              }), /*#__PURE__*/_jsx("td", {
                children: address !== null && address !== void 0 ? address : ""
              })]
            }), /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: "Website"
              }), /*#__PURE__*/_jsx("td", {
                children: website !== null && website !== void 0 ? website : ""
              })]
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.right,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.map_wrapper,
        children: htmlParse(map)
      })
    })]
  });
};

/* harmony default export */ var uni_campus = ((/* unused pure expression or super */ null && (uni_campus_UniCampus)));
;// CONCATENATED MODULE: ./_modules/study/university/template_two/tem_two_campus.jsx



var _excluded = (/* unused pure expression or super */ null && (["children", "value", "index"]));

function tem_two_campus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function tem_two_campus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? tem_two_campus_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : tem_two_campus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // Material ui related




function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_jsx("div", tem_two_campus_objectSpread(tem_two_campus_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "scrollable-auto-tabpanel-".concat(index),
    "aria-labelledby": "scrollable-auto-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/_jsx(Box, {
      p: 3,
      children: /*#__PURE__*/_jsx(Typography, {
        component: "div",
        children: children
      })
    })
  }));
}

function a11yProps(index) {
  return {
    id: "scrollable-auto-tab-".concat(index),
    "aria-controls": "scrollable-auto-tabpanel-".concat(index)
  };
}

var useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: "#fff"
    }
  };
});
var TemTwoCampus = function TemTwoCampus(_ref) {
  var uniCampus = _ref.uniCampus,
      universityData = _ref.universityData;
  var classes = useStyles();

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  return /*#__PURE__*/_jsx("section", {
    className: styles.tem_two_campus,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.wrapper,
        children: [/*#__PURE__*/_jsx("h2", {
          children: "Campus & Contact"
        }), /*#__PURE__*/_jsxs("div", {
          className: "uni_campuses",
          children: [uniCampus.length > 0 && /*#__PURE__*/_jsxs("div", {
            className: classes.root,
            children: [/*#__PURE__*/_jsx(AppBar, {
              position: "static",
              color: "default",
              children: /*#__PURE__*/_jsx(Tabs, {
                value: value,
                onChange: handleChange,
                indicatorColor: "primary",
                textColor: "primary",
                variant: "scrollable",
                scrollButtons: "auto",
                "aria-label": "scrollable auto tabs example",
                children: uniCampus.map(function (item, i) {
                  return /*#__PURE__*/_jsx(Tab, tem_two_campus_objectSpread({
                    label: item === null || item === void 0 ? void 0 : item.campusName
                  }, a11yProps(i)), i);
                })
              })
            }), uniCampus.map(function (item, i) {
              return /*#__PURE__*/_jsx(TabPanel, {
                value: value,
                index: i,
                children: /*#__PURE__*/_jsx(UniCampus, {
                  email: item.email,
                  phone: item.phone,
                  address: "".concat(item.city.name, ", ").concat(item.state.name, ", ").concat(item.country.name),
                  website: item.website,
                  map: item.googleMap
                })
              }, i);
            })]
          }), uniCampus.length == 0 && /*#__PURE__*/_jsx(UniCampus, {
            email: universityData.email,
            phone: universityData.phone,
            address: "".concat(universityData.city.name, ", ").concat(universityData.state.name, ", ").concat(universityData.country.name),
            website: universityData.website,
            map: universityData.googleMap
          })]
        })]
      })
    })
  });
};
/* harmony default export */ var tem_two_campus = ((/* unused pure expression or super */ null && (TemTwoCampus)));
;// CONCATENATED MODULE: ./_modules/study/university/template_two/like_dislike.jsx




var LikeDislike = function LikeDislike() {
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_like_deslike,
    children: /*#__PURE__*/_jsx("div", {
      className: "container",
      children: /*#__PURE__*/_jsx("div", {
        className: styles.wrapper,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.content_wrapper,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.title,
            children: "Was this page helpful?"
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.button_wrapper,
            children: [/*#__PURE__*/_jsxs("button", {
              className: "btn btn-secondary",
              children: [/*#__PURE__*/_jsx(MdOutlineThumbUpAlt, {}), /*#__PURE__*/_jsx("span", {
                children: "Like"
              })]
            }), /*#__PURE__*/_jsxs("button", {
              className: "btn btn-secondary",
              children: [/*#__PURE__*/_jsx(MdOutlineThumbDown, {}), /*#__PURE__*/_jsx("span", {
                children: "Dislike"
              })]
            })]
          })]
        })
      })
    })
  });
};
/* harmony default export */ var like_dislike = ((/* unused pure expression or super */ null && (LikeDislike)));
;// CONCATENATED MODULE: ./_modules/study/university/template_two/index.js









;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview.jsx













var UniOverview = function UniOverview(_ref) {
  var universityProfileData = _ref.universityProfileData;

  var _useState = (0,react.useState)({}),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return api/* default.get */.Z.get("/public/university-overview/info/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityId));

              case 4:
                res = _context.sent;
                setLoading(false);
                setData(res.data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: (0,helpers/* isEmpty */.xb)(data) ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        className: (uni_overview_module_default()).section_overview,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "container from_texteditor_wrapper",
          children: [(data === null || data === void 0 ? void 0 : data.highlight) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((uni_overview_module_default()).uni_overview_sec_wrapper, " ").concat((uni_overview_module_default()).highlights),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: "University Highlights"
            }), data ? (0,helpers/* htmlParse */.QA)(data === null || data === void 0 ? void 0 : data.highlight) : ""]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_overview_module_default()).uni_overview_sec_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: "University at a Glance"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: (uni_overview_module_default()).uni_ata_glance_list,
              children: [data !== null && data !== void 0 && data.internationalStudents && (data === null || data === void 0 ? void 0 : data.internationalStudents) != 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: "/assets/images/uni-profile/international-students.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_name,
                  children: ["International ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Students"]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (uni_overview_module_default()).uni_list_ratio,
                  children: data === null || data === void 0 ? void 0 : data.internationalStudents
                })]
              }) : "", data !== null && data !== void 0 && data.maleFemaleRatio && (data === null || data === void 0 ? void 0 : data.maleFemaleRatio) != 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: "/assets/images/uni-profile/male-female-ratio.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_name,
                  children: ["Male/Female ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Ratio"]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (uni_overview_module_default()).uni_list_ratio,
                  children: data === null || data === void 0 ? void 0 : data.maleFemaleRatio
                })]
              }) : "", data !== null && data !== void 0 && data.ugPgRatio && (data === null || data === void 0 ? void 0 : data.ugPgRatio) != 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: "/assets/images/uni-profile/ug-pg-course-ratio.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_name,
                  children: ["UG/PG Course ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Ratio"]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (uni_overview_module_default()).uni_list_ratio,
                  children: data === null || data === void 0 ? void 0 : data.ugPgRatio
                })]
              }) : "", data !== null && data !== void 0 && data.facultyRatio && (data === null || data === void 0 ? void 0 : data.facultyRatio) != 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: "/assets/images/uni-profile/faculty-student-ratio.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_name,
                  children: ["Faculty/Student ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Ratio"]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (uni_overview_module_default()).uni_list_ratio,
                  children: data === null || data === void 0 ? void 0 : data.facultyRatio
                })]
              }) : "", data !== null && data !== void 0 && data.noOfCampus && (data === null || data === void 0 ? void 0 : data.noOfCampus) != 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: "/assets/images/uni-profile/noof-campuses.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_name,
                  children: ["No. of ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Campuses"]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: (uni_overview_module_default()).uni_list_ratio,
                  children: data === null || data === void 0 ? void 0 : data.noOfCampus
                })]
              }) : "", data !== null && data !== void 0 && data.yearlyHotelMealExpenseFrom && (data === null || data === void 0 ? void 0 : data.yearlyHotelMealExpenseFrom) != 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_svg_esm/* ReactSVG */.Q, {
                  src: "/assets/images/uni-profile/yearly-expense.svg"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_name,
                  children: ["Yearly Hostel & ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Meals Expense"]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                  className: (uni_overview_module_default()).uni_list_ratio,
                  children: [data === null || data === void 0 ? void 0 : data.countryCurrencySymbol, (0,helpers/* numFormatter */.tV)(data === null || data === void 0 ? void 0 : data.yearlyHotelMealExpenseFrom), (data === null || data === void 0 ? void 0 : data.yearlyHotelMealExpenseTo) != 0 && (data === null || data === void 0 ? void 0 : data.yearlyHotelMealExpenseTo) && " - ", (data === null || data === void 0 ? void 0 : data.yearlyHotelMealExpenseTo) != 0 && (0,helpers/* numFormatter */.tV)(data === null || data === void 0 ? void 0 : data.yearlyHotelMealExpenseTo)]
                })]
              }) : ""]
            })]
          }), (data === null || data === void 0 ? void 0 : data.overview) && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "".concat((uni_overview_module_default()).uni_overview_sec_wrapper, " ").concat((uni_overview_module_default()).overview),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              children: "Overview"
            }), data !== null && data !== void 0 && data.overview ? (0,helpers/* htmlParse */.QA)(data === null || data === void 0 ? void 0 : data.overview) : ""]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(UniOverviewAccomodation, {
        overviewData: data,
        universityProfileData: universityProfileData
      })]
    })
  });
};
/* harmony default export */ var uni_overview = ((/* unused pure expression or super */ null && (UniOverview)));
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/uni_overview_admission.module.scss
var uni_overview_admission_module = __webpack_require__(96868);
var uni_overview_admission_module_default = /*#__PURE__*/__webpack_require__.n(uni_overview_admission_module);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_admission.jsx



/* eslint-disable react/jsx-no-target-blank */









var UniOverviewAdmission = function UniOverviewAdmission(_ref) {
  var _data$admissionRequir, _data$overviewData, _data$applicationFee, _data$applicationFee2, _data$applicationFee3, _data$applicationFee4, _data$overviewData2, _data$admissionRequir2;

  var universityProfileData = _ref.universityProfileData;

  var _useState = (0,react.useState)({}),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  var fetchData = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var res;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.next = 4;
              return api/* default.get */.Z.get("public/university-overview/adm-app-overview/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityId));

            case 4:
              res = _context.sent;
              setLoading(false);
              setData(res.data);
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              setLoading(false);
              setError("Something went wrong");

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function fetchData() {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    fetchData();
  }, []);
  var totalCourseCount = data === null || data === void 0 ? void 0 : (_data$admissionRequir = data.admissionRequirement) === null || _data$admissionRequir === void 0 ? void 0 : _data$admissionRequir.reduce(function (acc, curr) {
    return acc + parseInt(curr === null || curr === void 0 ? void 0 : curr.totalCourse);
  }, 0);
  var doc = data === null || data === void 0 ? void 0 : (_data$overviewData = data.overviewData) === null || _data$overviewData === void 0 ? void 0 : _data$overviewData.scholarshipHighlight;
  var minApplicationFeeCheck = (data === null || data === void 0 ? void 0 : (_data$applicationFee = data.applicationFee) === null || _data$applicationFee === void 0 ? void 0 : _data$applicationFee.minapplicationfee) == null || (data === null || data === void 0 ? void 0 : (_data$applicationFee2 = data.applicationFee) === null || _data$applicationFee2 === void 0 ? void 0 : _data$applicationFee2.minapplicationfee) == "0.00" ? false : true;
  var maxApplicationFeeCheck = (data === null || data === void 0 ? void 0 : (_data$applicationFee3 = data.applicationFee) === null || _data$applicationFee3 === void 0 ? void 0 : _data$applicationFee3.maxapplicationfee) == null || (data === null || data === void 0 ? void 0 : (_data$applicationFee4 = data.applicationFee) === null || _data$applicationFee4 === void 0 ? void 0 : _data$applicationFee4.maxapplicationfee) == "0.00" ? false : true;
  var aplicationFeeCheck = maxApplicationFeeCheck || minApplicationFeeCheck;
  var appFeesResise = "";

  if (minApplicationFeeCheck && maxApplicationFeeCheck) {
    var _data$applicationFee5, _data$applicationFee6, _data$applicationFee7, _data$applicationFee8;

    appFeesResise = (data === null || data === void 0 ? void 0 : (_data$applicationFee5 = data.applicationFee) === null || _data$applicationFee5 === void 0 ? void 0 : (_data$applicationFee6 = _data$applicationFee5.minapplicationfee) === null || _data$applicationFee6 === void 0 ? void 0 : _data$applicationFee6.replace(".00", "")) + " - " + (data === null || data === void 0 ? void 0 : (_data$applicationFee7 = data.applicationFee) === null || _data$applicationFee7 === void 0 ? void 0 : (_data$applicationFee8 = _data$applicationFee7.maxapplicationfee) === null || _data$applicationFee8 === void 0 ? void 0 : _data$applicationFee8.replace(".00", ""));
  } else if (minApplicationFeeCheck && !maxApplicationFeeCheck) {
    var _data$applicationFee9, _data$applicationFee10;

    appFeesResise = data === null || data === void 0 ? void 0 : (_data$applicationFee9 = data.applicationFee) === null || _data$applicationFee9 === void 0 ? void 0 : (_data$applicationFee10 = _data$applicationFee9.minapplicationfee) === null || _data$applicationFee10 === void 0 ? void 0 : _data$applicationFee10.replace(".00", "");
  } else if (!minApplicationFeeCheck && maxApplicationFeeCheck) {
    var _data$applicationFee11, _data$applicationFee12;

    appFeesResise = data === null || data === void 0 ? void 0 : (_data$applicationFee11 = data.applicationFee) === null || _data$applicationFee11 === void 0 ? void 0 : (_data$applicationFee12 = _data$applicationFee11.maxapplicationfee) === null || _data$applicationFee12 === void 0 ? void 0 : _data$applicationFee12.replace(".00", "");
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: totalCourseCount || doc || aplicationFeeCheck ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (uni_overview_admission_module_default()).section_admission,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_overview_admission_module_default()).title_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Fees & Admissions Requirements"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (uni_overview_admission_module_default()).short_description,
            children: ["Check out the tuition fee ranges, entry requirements, intake dates, ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "and more for ", universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
          container: true,
          spacing: 6,
          className: (uni_overview_admission_module_default()).content_wrapper,
          justifyContent: "center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 10,
            className: "from_texteditor_wrapper",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_overview_admission_module_default()).table_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                      colSpan: "2",
                      children: "Admission Requirements"
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("tbody", {
                  children: [doc && /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Documents"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      children: data !== null && data !== void 0 && data.overviewData.scholarshipHighlight ? (0,helpers/* htmlParse */.QA)(data === null || data === void 0 ? void 0 : (_data$overviewData2 = data.overviewData) === null || _data$overviewData2 === void 0 ? void 0 : _data$overviewData2.scholarshipHighlight) : ""
                    })]
                  }), aplicationFeeCheck ? /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Application fees"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("td", {
                      children: [universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countryCurrency, " ", appFeesResise]
                    })]
                  }) : null, data && totalCourseCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                        children: "Courses"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
                        className: (uni_overview_admission_module_default()).coursesList,
                        children: data === null || data === void 0 ? void 0 : (_data$admissionRequir2 = data.admissionRequirement) === null || _data$admissionRequir2 === void 0 ? void 0 : _data$admissionRequir2.map(function (item, i) {
                          var _item$levelName;

                          return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
                            children: (item === null || item === void 0 ? void 0 : item.totalCourse) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                className: (uni_overview_admission_module_default()).courseLevelName,
                                children: item === null || item === void 0 ? void 0 : item.levelName
                              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                                  legacyBehavior: true,
                                  href: "/study/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countrySlug, "/university/").concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universitySlug, "/courses?crl=").concat(item === null || item === void 0 ? void 0 : (_item$levelName = item.levelName) === null || _item$levelName === void 0 ? void 0 : _item$levelName.toLowerCase()),
                                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                                    className: (uni_overview_admission_module_default()).course_list_course_link,
                                    children: ["(", item === null || item === void 0 ? void 0 : item.totalCourse, " ", (item === null || item === void 0 ? void 0 : item.totalCourse) > 1 ? "Courses" : "Course", ")"]
                                  })
                                })
                              }), (item === null || item === void 0 ? void 0 : item.minDuration) + (item === null || item === void 0 ? void 0 : item.maxDuration) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                children: ["Duration:", " ", item !== null && item !== void 0 && item.minDuration ? (0,helpers/* calcDuration */.LF)(item === null || item === void 0 ? void 0 : item.minDuration) : "", " ", (item === null || item === void 0 ? void 0 : item.maxDuration) && "- ", item !== null && item !== void 0 && item.maxDuration ? (0,helpers/* calcDuration */.LF)(item === null || item === void 0 ? void 0 : item.maxDuration) : ""]
                              }), (item === null || item === void 0 ? void 0 : item.minAmount) + (item === null || item === void 0 ? void 0 : item.maxAmount) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                                children: ["1st Year Tution Fees:", " ", (item === null || item === void 0 ? void 0 : item.minAmount) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                  children: [universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countryCurrencySymbol, (0,helpers/* numFormatter */.tV)(item.minAmount)]
                                }), (item === null || item === void 0 ? void 0 : item.maxAmount) && item.maxAmount != 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                  children: " - ".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countryCurrencySymbol).concat((0,helpers/* numFormatter */.tV)(item.maxAmount))
                                })]
                              })]
                            })
                          }, i);
                        })
                      })
                    })]
                  })]
                })]
              })
            })
          })
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
  });
};
/* harmony default export */ var uni_overview_admission = ((/* unused pure expression or super */ null && (UniOverviewAdmission)));
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./_modules/study/common/scholarship_card/index.jsx
var scholarship_card = __webpack_require__(19803);
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/uni_overview_scholarship.module.scss
var uni_overview_scholarship_module = __webpack_require__(54729);
var uni_overview_scholarship_module_default = /*#__PURE__*/__webpack_require__.n(uni_overview_scholarship_module);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_scholarship.jsx



/* eslint-disable react/jsx-no-target-blank */









var UniOverviewScholarship = function UniOverviewScholarship(_ref) {
  var universityProfileData = _ref.universityProfileData;
  var router = (0,next_router.useRouter)();
  var query = router.query;

  var _useState = (0,react.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return api/* default.get */.Z.get("/public/university-scholarship/list/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universitySlug, "?limit=4"));

              case 4:
                res = _context.sent;
                setLoading(false);
                setData(res.data.results);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: (data === null || data === void 0 ? void 0 : data.length) == 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_overview_scholarship_module_default()).title_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Popular scholarships"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (uni_overview_scholarship_module_default()).short_description,
            children: ["Planning to apply for scholarships to study at", " ", universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, "?", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Get started on the process by exploring the", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
              children: "international student scholarship"
            }), " options below!"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
          container: true,
          spacing: 3,
          justifyContent: "center",
          children: data === null || data === void 0 ? void 0 : data.map(function (item, i) {
            var _universityProfileDat, _item$badge;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
              item: true,
              xs: 12,
              sm: 6,
              md: 4,
              lg: 3,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(scholarship_card/* default */.Z, {
                countryCurrencySymbol: universityProfileData === null || universityProfileData === void 0 ? void 0 : (_universityProfileDat = universityProfileData.universityData) === null || _universityProfileDat === void 0 ? void 0 : _universityProfileDat.countryCurrencySymbol,
                name: item === null || item === void 0 ? void 0 : item.scholarshipName,
                amount: item === null || item === void 0 ? void 0 : item.scholarshipAmount,
                deadline: item === null || item === void 0 ? void 0 : item.deadline,
                link: "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/scholarships/").concat(item === null || item === void 0 ? void 0 : item.slug),
                badge: (_item$badge = item.badge) !== null && _item$badge !== void 0 ? _item$badge : []
              })
            }, i);
          })
        })]
      })
    })
  });
};
/* harmony default export */ var uni_overview_scholarship = ((/* unused pure expression or super */ null && (UniOverviewScholarship)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
;// CONCATENATED MODULE: ./_modules/skeleton/course_skeleton.jsx



var CourseSkeleton = function CourseSkeleton() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
    container: true,
    spacing: 2,
    alignItems: "center",
    children: [1, 2, 3, 4, 5, 6, 7, 8].map(function (item, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid_Grid/* default */.ZP, {
        item: true,
        xs: 12,
        sm: 12,
        md: 3,
        lg: 3,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 250
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 20,
          sx: {
            margin: "10px 0px 10px 0px"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
          variant: "rectangular",
          width: "100%",
          height: 20,
          sx: {
            margin: "10px 0px 20px 0px"
          }
        })]
      }, i);
    })
  });
};
/* harmony default export */ var course_skeleton = (CourseSkeleton);
// EXTERNAL MODULE: ./_modules/study/common/course_card/index.jsx
var course_card = __webpack_require__(316);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box_Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/AppBar/AppBar.js + 1 modules
var AppBar_AppBar = __webpack_require__(85050);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tabs/Tabs.js + 6 modules
var Tabs_Tabs = __webpack_require__(62348);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tab/Tab.js + 1 modules
var Tab_Tab = __webpack_require__(18661);
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/uni_overview_courses.module.scss
var uni_overview_courses_module = __webpack_require__(82334);
var uni_overview_courses_module_default = /*#__PURE__*/__webpack_require__.n(uni_overview_courses_module);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_courses.jsx



var uni_overview_courses_excluded = ["children", "value", "index"];


function uni_overview_courses_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function uni_overview_courses_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? uni_overview_courses_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : uni_overview_courses_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function uni_overview_courses_TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = (0,objectWithoutProperties/* default */.Z)(props, uni_overview_courses_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", uni_overview_courses_objectSpread(uni_overview_courses_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "scrollable-auto-tabpanel-".concat(index),
    "aria-labelledby": "scrollable-auto-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
      p: 3,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        component: "div",
        children: children
      })
    })
  }));
}

function uni_overview_courses_a11yProps(index) {
  return {
    id: "scrollable-auto-tab-".concat(index),
    "aria-controls": "scrollable-auto-tabpanel-".concat(index)
  };
}

var uni_overview_courses_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: "transparent"
    }
  };
});
var UniOverviewCourses = function UniOverviewCourses(_ref) {
  var universityProfileData = _ref.universityProfileData;
  var router = (0,next_router.useRouter)();
  var query = router.query;
  var classes = uni_overview_courses_useStyles();

  var _useState = (0,react.useState)(false),
      loader = _useState[0],
      setLoader = _useState[1];

  var _useState2 = (0,react.useState)(0),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      index = _useState3[0],
      setIndex = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      level = _useState4[0],
      setSlug = _useState4[1];

  var _useState5 = (0,react.useState)(0),
      totalCourseCounted = _useState5[0],
      setTotalCourseCounted = _useState5[1];

  var _useState6 = (0,react.useState)([]),
      courses = _useState6[0],
      setCourses = _useState6[1];

  var _useState7 = (0,react.useState)([]),
      courseLevelData = _useState7[0],
      setCourseLevelData = _useState7[1];

  var _useState8 = (0,react.useState)(false),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var university_name = universityProfileData.universitySlug;
  var slugLink = level == "topcourse" || level == "" ? "sbp=1" : "crl=".concat(level);
  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                setLoading(true);
                _context2.next = 3;
                return api/* default.get */.Z.get("/public/course-level/".concat(university_name)).then( /*#__PURE__*/function () {
                  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(resp) {
                    var _resp$data, levels, _levels$, levelSlug;

                    return regenerator_default().wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!(!resp.error && resp.data)) {
                              _context.next = 7;
                              break;
                            }

                            levels = (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.filter(function (item, i) {
                              return (item === null || item === void 0 ? void 0 : item.totalCourse) != null && parseInt(item === null || item === void 0 ? void 0 : item.totalCourse) != 0;
                            });

                            if (!(levels !== null && levels !== void 0 && levels.length && (levels === null || levels === void 0 ? void 0 : levels.length) > 0)) {
                              _context.next = 6;
                              break;
                            }

                            levelSlug = (_levels$ = levels[0]) === null || _levels$ === void 0 ? void 0 : _levels$.levelSlug;
                            _context.next = 6;
                            return api/* default.get */.Z.get("/public/university-course/".concat(university_name, "/").concat(levelSlug, "?limit=12&page=1")).then(function (rsp) {
                              if (!rsp.error && rsp.data) {
                                var _rsp$data, _rsp$data$courseData, _rsp$data2, _rsp$data2$courseData;

                                setLoading(true);
                                setCourses(rsp === null || rsp === void 0 ? void 0 : (_rsp$data = rsp.data) === null || _rsp$data === void 0 ? void 0 : (_rsp$data$courseData = _rsp$data.courseData) === null || _rsp$data$courseData === void 0 ? void 0 : _rsp$data$courseData.results);
                                setTotalCourseCounted(rsp === null || rsp === void 0 ? void 0 : (_rsp$data2 = rsp.data) === null || _rsp$data2 === void 0 ? void 0 : (_rsp$data2$courseData = _rsp$data2.courseData) === null || _rsp$data2$courseData === void 0 ? void 0 : _rsp$data2$courseData.total);
                              }
                            });

                          case 6:
                            setCourseLevelData(resp.data);

                          case 7:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []); //end

  var filteredLevel = courseLevelData === null || courseLevelData === void 0 ? void 0 : courseLevelData.filter(function (item, i) {
    return (item === null || item === void 0 ? void 0 : item.totalCourse) != null && parseInt(item === null || item === void 0 ? void 0 : item.totalCourse) != 0;
  });

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  }; //course handler


  var handleCourses = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(slug) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setCourses([]);
              setLoader(true);
              _context3.next = 4;
              return api/* default.get */.Z.get("/public/university-course/".concat(query.university_name, "/").concat(slug, "?limit=8&page=1")).then(function (rsp) {
                if (!rsp.error && rsp.data) {
                  var _rsp$data3, _rsp$data3$courseData, _rsp$data4, _rsp$data4$courseData;

                  setCourses(rsp === null || rsp === void 0 ? void 0 : (_rsp$data3 = rsp.data) === null || _rsp$data3 === void 0 ? void 0 : (_rsp$data3$courseData = _rsp$data3.courseData) === null || _rsp$data3$courseData === void 0 ? void 0 : _rsp$data3$courseData.results);
                  setTotalCourseCounted(rsp === null || rsp === void 0 ? void 0 : (_rsp$data4 = rsp.data) === null || _rsp$data4 === void 0 ? void 0 : (_rsp$data4$courseData = _rsp$data4.courseData) === null || _rsp$data4$courseData === void 0 ? void 0 : _rsp$data4$courseData.total);
                }

                setLoader(false);
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleCourses(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: filteredLevel && (filteredLevel === null || filteredLevel === void 0 ? void 0 : filteredLevel.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: (uni_overview_courses_module_default()).section_courses,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (uni_overview_courses_module_default()).title_wrapper,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "All Courses"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (uni_overview_courses_module_default()).short_description,
            children: ["Explore the courses ", universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " has to offer to find the right program for you!"]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (uni_overview_courses_module_default()).tabs_wrapper,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "uni_courses",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: classes.root,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppBar_AppBar/* default */.Z, {
                position: "static",
                color: "default",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_Tabs/* default */.Z, {
                  value: value,
                  onChange: handleChange,
                  indicatorColor: "primary",
                  textColor: "primary",
                  variant: "scrollable",
                  scrollButtons: true,
                  allowScrollButtonsMobile: true,
                  "aria-label": "scrollable auto tabs example",
                  children: filteredLevel === null || filteredLevel === void 0 ? void 0 : filteredLevel.map(function (level, i) {
                    return /*#__PURE__*/(0,react.createElement)(Tab_Tab/* default */.Z, uni_overview_courses_objectSpread(uni_overview_courses_objectSpread({
                      label: "".concat(level === null || level === void 0 ? void 0 : level.levelName)
                    }, uni_overview_courses_a11yProps(i)), {}, {
                      key: i,
                      onClick: function onClick() {
                        setIndex(i);
                        setSlug(level.levelSlug);
                        handleCourses(level.levelSlug);
                      }
                    }));
                  })
                })
              }), loader ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                style: {
                  paddingTop: "40px"
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(course_skeleton, {})
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: courses && (courses === null || courses === void 0 ? void 0 : courses.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(uni_overview_courses_TabPanel, {
                  value: value,
                  index: index,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
                    container: true,
                    spacing: {
                      xs: 2,
                      sm: 2,
                      md: 3
                    },
                    justifyContent: "center",
                    children: courses.map(function (course, i) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 6,
                        md: 4,
                        lg: 3,
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(course_card/* default */.Z, {
                          link: "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/").concat(course === null || course === void 0 ? void 0 : course.courseSlug),
                          name: course === null || course === void 0 ? void 0 : course.courseName,
                          level: course === null || course === void 0 ? void 0 : course.courseLevel,
                          session: course === null || course === void 0 ? void 0 : course.sessionName,
                          duration: course === null || course === void 0 ? void 0 : course.courseDuration,
                          intakes: course === null || course === void 0 ? void 0 : course.intakes,
                          amountFrom: course === null || course === void 0 ? void 0 : course.feesAmountFrom,
                          amountTo: course === null || course === void 0 ? void 0 : course.feesAmountTo,
                          countryCurrency: universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.countryCurrency
                        })
                      }, i);
                    })
                  }), totalCourseCounted > 8 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: (uni_overview_courses_module_default()).btn_wrapper,
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                      legacyBehavior: true,
                      href: "/study/".concat(query.country_name, "/university/").concat(query.university_name, "/courses?").concat(slugLink),
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                        className: "btn btn-secondary btn-bg",
                        children: ["View ", totalCourseCounted * 1 - 8, " more", " ", totalCourseCounted * 1 - 8 > 1 ? "courses" : "course"]
                      })
                    })
                  })]
                })
              })]
            })
          })
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
  });
};
/* harmony default export */ var uni_overview_courses = ((/* unused pure expression or super */ null && (UniOverviewCourses)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/uni_overview_campus.module.scss
var uni_overview_campus_module = __webpack_require__(79675);
var uni_overview_campus_module_default = /*#__PURE__*/__webpack_require__.n(uni_overview_campus_module);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_campus.jsx




var uni_overview_campus_excluded = ["children", "value", "index"];


function uni_overview_campus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function uni_overview_campus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? uni_overview_campus_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : uni_overview_campus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/jsx-no-target-blank */













function uni_overview_campus_TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = (0,objectWithoutProperties/* default */.Z)(props, uni_overview_campus_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", uni_overview_campus_objectSpread(uni_overview_campus_objectSpread({
    role: "tabpanel",
    hidden: value !== index,
    id: "scrollable-auto-tabpanel-".concat(index),
    "aria-labelledby": "scrollable-auto-tab-".concat(index)
  }, other), {}, {
    children: value === index && /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
      p: 3,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
        component: "div",
        children: children
      })
    })
  }));
}

function uni_overview_campus_a11yProps(index) {
  return {
    id: "scrollable-auto-tab-".concat(index),
    "aria-controls": "scrollable-auto-tabpanel-".concat(index)
  };
}

var uni_overview_campus_useStyles = (0,makeStyles/* default */.Z)(function (theme) {
  return {
    root: {
      flexGrow: 1,
      width: "100%",
      backgroundColor: "#fff"
    }
  };
});
var UniOverviewCampus = function UniOverviewCampus(_ref) {
  var universityProfileData = _ref.universityProfileData;
  var classes = uni_overview_campus_useStyles();

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
  };

  var _useState = (0,react.useState)([]),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = (0,react.useState)(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)(""),
      error = _useState3[0],
      setError = _useState3[1];

  (0,react.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        var res;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                setLoading(true);
                _context.next = 4;
                return api/* default.get */.Z.get("/public/university-campus/".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universitySlug));

              case 4:
                res = _context.sent;
                setLoading(false);
                setData(res.data);
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                setLoading(false);
                setError("Something went wrong");

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 9]]);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (uni_overview_campus_module_default()).title_wrapper,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          children: "Campus & Contact"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (uni_overview_campus_module_default()).short_description,
          children: ["Explore", " ", /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            style: {
              fontWeight: 500
            },
            children: [universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, "\u2019s", " "]
          }), "campuses, location, and surroundings, and get in touch with the university itself to find out more!"]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (uni_overview_campus_module_default()).campuses_wrapper,
        children: (data === null || data === void 0 ? void 0 : data.length) == 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid_Grid/* default */.ZP, {
          container: true,
          spacing: 0,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 6,
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_overview_campus_module_default()).campus_address_wrapper,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: (uni_overview_campus_module_default()).campus_address_title,
                children: "Main Campus"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                className: (uni_overview_campus_module_default()).address,
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaMapMarkerAlt */.Nh4, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: ["Address: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.address]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdMail */.h6V, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: ["Email: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.email]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPhone */.IXo, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    children: ["Phone: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.phone]
                  })]
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 6,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((uni_overview_campus_module_default()).map_wrapper, " CampusMapWrapper"),
              children: universityProfileData !== null && universityProfileData !== void 0 && universityProfileData.location ? (0,html_react_parser/* default */.ZP)(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.location) : ""
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid_Grid/* default */.ZP, {
          container: true,
          spacing: {
            xs: 2,
            md: 3
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 6,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_overview_campus_module_default()).tabs_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "uni_campuses",
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: classes.root,
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppBar_AppBar/* default */.Z, {
                    position: "static",
                    color: "default",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_Tabs/* default */.Z, {
                      value: value,
                      onChange: handleChange,
                      indicatorColor: "primary",
                      textColor: "primary",
                      variant: "scrollable",
                      scrollButtons: "auto",
                      "aria-label": "scrollable auto tabs example",
                      children: data.map(function (campus, i) {
                        return /*#__PURE__*/(0,react.createElement)(Tab_Tab/* default */.Z, uni_overview_campus_objectSpread(uni_overview_campus_objectSpread({
                          label: campus === null || campus === void 0 ? void 0 : campus.campusName
                        }, uni_overview_campus_a11yProps(i)), {}, {
                          key: i
                        }));
                      })
                    })
                  }), data === null || data === void 0 ? void 0 : data.map(function (campus, i) {
                    return /*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview_campus_TabPanel, {
                      value: value,
                      index: i,
                      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                        className: (uni_overview_campus_module_default()).address,
                        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FaMapMarkerAlt */.Nh4, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                            children: ["Address: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), campus === null || campus === void 0 ? void 0 : campus.campusAddress]
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdMail */.h6V, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                            children: ["Email: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), campus === null || campus === void 0 ? void 0 : campus.campusEmail]
                          })]
                        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(md_index_esm/* MdPhone */.IXo, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                            children: ["Phone: ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), campus === null || campus === void 0 ? void 0 : campus.campusPhone]
                          })]
                        })]
                      })
                    }, i);
                  })]
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid_Grid/* default */.ZP, {
            item: true,
            xs: 12,
            sm: 12,
            md: 6,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "".concat((uni_overview_campus_module_default()).map_wrapper, " CampusMapWrapper"),
              children: data.map(function (campus, i) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview_campus_TabPanel, {
                  value: value,
                  index: i,
                  style: {
                    height: "100%"
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                    src: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14610.12323499123!2d".concat(campus === null || campus === void 0 ? void 0 : campus.campusLongitude, "!3d").concat(campus === null || campus === void 0 ? void 0 : campus.campusLattitude, "!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1641754942272!5m2!1sen!2sbd"),
                    width: "100%",
                    height: "356px",
                    style: {
                      border: 0
                    },
                    allowfullssreen: "",
                    loading: "lazy"
                  })
                }, i);
              })
            })
          })]
        })
      })]
    })
  });
};
/* harmony default export */ var uni_overview_campus = ((/* unused pure expression or super */ null && (UniOverviewCampus)));
// EXTERNAL MODULE: ./_modules/study/common/top_rank_uni_card/index.jsx
var top_rank_uni_card = __webpack_require__(49922);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/uni_overview_popular_university.jsx










function NextArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronRight */.Tfp, {
    className: "ReviewSliderTextArrowNext",
    onClick: onClick
  });
}

function PrevArrow(props) {
  var className = props.className,
      style = props.style,
      onClick = props.onClick;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiChevronLeft */.YFh, {
    className: "ReviewSliderTextArrowPrev",
    onClick: onClick
  });
}

var settings = {
  dots: true,
  className: "TopRankCardSlider",
  centerMode: false,
  infinite: true,
  centerPadding: "60px",
  slidesToShow: 3,
  speed: 500,
  rows: 2,
  arrows: false,
  // slidesPerRow: 1,
  slidesToScroll: 3,
  nextArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(NextArrow, {}),
  prevArrow: /*#__PURE__*/(0,jsx_runtime.jsx)(PrevArrow, {}),
  responsive: [{
    breakpoint: 1100,
    settings: {
      arrows: false,
      centerMode: false,
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 900,
    settings: {
      arrows: false,
      centerMode: false,
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 750,
    settings: {
      rows: 1,
      arrows: true,
      dots: false,
      centerMode: false,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};
var UniOverviewPopularUniversity = function UniOverviewPopularUniversity() {
  return /*#__PURE__*/_jsx("section", {
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.title_wrapper,
        children: [/*#__PURE__*/_jsx("h2", {
          children: "Popular Universities"
        }), /*#__PURE__*/_jsx("p", {
          className: styles.short_description,
          children: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dictum nunc donec vulputate ut in sapien nunc, sit. Amet, viverra arcu est, imperdiet. Porta sollicitudin tempus odio gravida eget."
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "top-rank-slider-wrapper ".concat(styles.top_rank_card_wrapper),
        children: /*#__PURE__*/_jsxs(Grid, {
          container: true,
          spacing: 4,
          children: [/*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 4,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/_jsx(TopRankUniCard, {})
          }), /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 4,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/_jsx(TopRankUniCard, {})
          }), /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 4,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/_jsx(TopRankUniCard, {})
          }), /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 4,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/_jsx(TopRankUniCard, {})
          }), /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 4,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/_jsx(TopRankUniCard, {})
          }), /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 4,
            sm: 12,
            xs: 12,
            children: /*#__PURE__*/_jsx(TopRankUniCard, {})
          })]
        })
      })]
    })
  });
};
/* harmony default export */ var uni_overview_popular_university = ((/* unused pure expression or super */ null && (UniOverviewPopularUniversity)));
;// CONCATENATED MODULE: ./_modules/study/university/uni_overview/index.js













/***/ }),

/***/ 69805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ UniProfileBanner; }
/* harmony export */ });
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98576);
/* harmony import */ var _uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var UniProfileBanner = function UniProfileBanner(_ref) {
  var uniProfileData = _ref.uniProfileData;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("section", {
    className: (_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default().section_banner),
    children: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.featureSrc) &&
    /*#__PURE__*/
    // <div className={styles.banner_wrapper}>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        layout: "responsive",
        width: 1905,
        height: 450,
        blurDataURL: (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        placeholder: "blur",
        className: (_uni_profile_banner_module_scss__WEBPACK_IMPORTED_MODULE_4___default().banner_image),
        src: (uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.featureSrc) || (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getAssets */ .Vh)("assets/images/image_placeholder_big.webp"),
        alt: "Video Background"
      })
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileBanner)));

/***/ }),

/***/ 55912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniProfileLinks */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var UniProfileLinks = function UniProfileLinks(props) {
  var pageData = props.pageData;
  var link = useRouter();
  var asPath = link.asPath,
      query = link.query;
  var universityName = query.university_name;
  var countryName = query.country_name;
  var courseName = query.course_slug;
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_links,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.links_wrapper,
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsx("div", {
          className: styles.links_container,
          children: /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName) ? "".concat(styles.active) : ""),
                  children: "Overview"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/admission-faq"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/admission-faq") ? "".concat(styles.active) : ""),
                  children: "Admission FAQs"
                })
              })
            }), (props === null || props === void 0 ? void 0 : props.showRankingTab) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/ranking"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/ranking") ? "".concat(styles.active) : ""),
                  children: "Ranking"
                })
              })
            }), (props === null || props === void 0 ? void 0 : props.showScholarshipTab) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/scholarships"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/scholarships") ? "".concat(styles.active) : ""),
                  children: "Scholarships"
                })
              })
            }), (props === null || props === void 0 ? void 0 : props.showCourseTab) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/courses"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/courses") ? "".concat(styles.active) : ""),
                  children: "Courses"
                })
              })
            }), asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/").concat(courseName) && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/").concat(countryName),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/").concat(courseName) ? "".concat(styles.active) : ""),
                  children: "Course Details"
                })
              })
            }), (pageData === null || pageData === void 0 ? void 0 : pageData.length) > 0 && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/blog"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/blog") ? "".concat(styles.active) : ""),
                  children: "Blog"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/staff"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/staff") ? "".concat(styles.active) : ""),
                  children: "Staff"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/event-fair"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/event-fair") ? "".concat(styles.active) : ""),
                  children: "Event/Fair"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/gallery"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/gallery") ? "".concat(styles.active) : ""),
                  children: "Gallery"
                })
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(Link, {
                legacyBehavior: true,
                href: "/study/".concat(countryName, "/university/").concat(universityName, "/contact"),
                children: /*#__PURE__*/_jsx("a", {
                  className: "".concat(asPath === "/study/".concat(countryName, "/university/").concat(universityName, "/contact") ? "".concat(styles.active) : ""),
                  children: "Contact"
                })
              })
            })]
          })
        })
      })
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileLinks)));

/***/ }),

/***/ 65111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UniProfileUniBox */
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73873);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41548);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_uni_thumb_grid_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32182);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var UniProfileUniBox = function UniProfileUniBox(_ref) {
  var universities = _ref.universities;
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1400,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 4
      }
    }, {
      breakpoint: 1200,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 3
      }
    }, {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 2
      }
    }, {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        slidesToShow: 1
      }
    }]
  };
  return /*#__PURE__*/_jsx("section", {
    className: styles.section_uni_profile_box,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.uni_profile_box,
      children: /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, settings), {}, {
        children: universities === null || universities === void 0 ? void 0 : universities.slice(0, 10).map(function (university, i) {
          var _university$country, _university$featuredI, _university$featuredI2, _university$logo, _university$logo2, _university$city, _university$state, _university$country2, _university$country3;

          return /*#__PURE__*/_jsx(UniThumbGridBox, {
            universityLink: "/study/".concat(university === null || university === void 0 ? void 0 : (_university$country = university.country) === null || _university$country === void 0 ? void 0 : _university$country.slug, "/university/").concat(university === null || university === void 0 ? void 0 : university.slug),
            name: university === null || university === void 0 ? void 0 : university.name,
            featuredImage: university === null || university === void 0 ? void 0 : (_university$featuredI = university.featuredImage) === null || _university$featuredI === void 0 ? void 0 : _university$featuredI.src,
            featuredImageAlt: university === null || university === void 0 ? void 0 : (_university$featuredI2 = university.featuredImage) === null || _university$featuredI2 === void 0 ? void 0 : _university$featuredI2.alt,
            logo: university === null || university === void 0 ? void 0 : (_university$logo = university.logo) === null || _university$logo === void 0 ? void 0 : _university$logo.src,
            logoAlt: university === null || university === void 0 ? void 0 : (_university$logo2 = university.logo) === null || _university$logo2 === void 0 ? void 0 : _university$logo2.alt,
            address: university === null || university === void 0 ? void 0 : university.address,
            city: (university === null || university === void 0 ? void 0 : (_university$city = university.city) === null || _university$city === void 0 ? void 0 : _university$city.name) || "City",
            state: (university === null || university === void 0 ? void 0 : (_university$state = university.state) === null || _university$state === void 0 ? void 0 : _university$state.name) || "State",
            country: (university === null || university === void 0 ? void 0 : (_university$country2 = university.country) === null || _university$country2 === void 0 ? void 0 : _university$country2.name) || "Country",
            universityType: university.universityType,
            estd: university === null || university === void 0 ? void 0 : university.estd,
            courseLink: "/study/".concat(university === null || university === void 0 ? void 0 : (_university$country3 = university.country) === null || _university$country3 === void 0 ? void 0 : _university$country3.slug, "/university/").concat(university === null || university === void 0 ? void 0 : university.slug, "/courses"),
            courseNumber: university.course.length
          }, university.id);
        })
      }))
    })
  });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (UniProfileUniBox)));

/***/ }),

/***/ 17171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(28719);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88740);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72145);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67555);
/* harmony import */ var react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react_phone_input_2__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31955);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var customStyles = {
  control: function control(base, state) {
    var _objectSpread2;

    return _objectSpread(_objectSpread({}, base), {}, (_objectSpread2 = {
      height: "60px",
      boxShadow: state.isFocused ? "0px 4px 15px rgba(244, 127, 32, 0.15)" : "none",
      borderColor: "#eeeeee",
      "&:hover": {
        borderColor: "#eeeeee"
      }
    }, (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "borderColor", state.isFocused ? "#F47F20" : "#eeeeee"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "backgroundColor", "#fff"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "fontSize", "13px"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "borderRadius", "8px"), (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_objectSpread2, "padding", "0 20px"), _objectSpread2));
  },
  option: function option(provided, state) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      cursor: "pointer",
      color: state.isSelected ? "#F47F20" : "#B5B5C3",
      backgroundColor: state.isSelected ? "#F5F6FC" : state.isFocused ? "#fff" : provided.backgroundColor,
      fontSize: "13px",
      "&:hover": {
        backgroundColor: "#F5F6FC",
        color: "#F47F20"
      }
    });
  },
  menuPortal: function menuPortal(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      zIndex: 9999
    });
  }
};
var init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "guest",
  reviewerName: "",
  reviewerEmail: "",
  reviewComment: "",
  reviewerPhone: "",
  reviewerCountryId: undefined
};

var GuestFormReview = function GuestFormReview(_ref) {
  var uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
  var asPath = router.asPath;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      lastName = _useState[0],
      setLastName = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]),
      countryList = _useState2[0],
      setCountryList = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(init),
      formData = _useState3[0],
      setFormData = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("in"),
      defaultCountryCode = _useState4[0],
      setDefaultCountryCode = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    setTimeout(function () {
      if (js_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"].get */ .Z.get("default_country")) {
        setDefaultCountryCode(js_cookie__WEBPACK_IMPORTED_MODULE_9__/* ["default"].get */ .Z.get("default_country"));
      }
    }, 1500);
  }, [defaultCountryCode]); // all country list

  var getCountryList = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].get */ .Z.get("/public/country/dropdown").then(function (res) {
                if (!res.error) {
                  setCountryList(res.data);
                } else {
                  setCountryList([]);
                }
              })["catch"](function (error) {
                setCountryList([]);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getCountryList() {
      return _ref2.apply(this, arguments);
    };
  }(); // fetch only country


  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    getCountryList();
  }, []); // validation schema

  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry().shape({
    rating: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Please give rating"),
    reviewerName: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewerEmail: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewerCountryId: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required"),
    reviewComment: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().required("Field is required")
  });

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                universityId: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityId,
                rating: values.rating,
                reviewerType: "guest",
                reviewerName: "".concat(values.reviewerName, " ").concat(lastName),
                reviewerEmail: values.reviewerEmail,
                reviewComment: values.reviewComment,
                reviewerPhone: values.reviewerPhone,
                reviewerCountryId: values.reviewerCountryId
              };
              _context3.next = 3;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/public/university-review", payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 8;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .swalSuccess */ .Xt)("Submitted");
                          setModal(false);
                          _context2.next = 5;
                          return getData();

                        case 5:
                          router.push(asPath);
                          _context2.next = 9;
                          break;

                        case 8:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_6__/* .swalError */ .Kj)(res === null || res === void 0 ? void 0 : res.message, "Sorry");

                        case 9:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmitForm(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
    className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().wrapper),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Formik */ .J9, {
      initialValues: formData,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values) {
        handleSubmitForm(values);
      },
      children: function children(_ref5) {
        var handleSubmit = _ref5.handleSubmit,
            setFieldValue = _ref5.setFieldValue,
            values = _ref5.values,
            errors = _ref5.errors,
            touched = _ref5.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_4__/* .Form */ .l0, {
          className: "form",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
            className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().rating_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
              sx: {
                fontSize: "50px"
              },
              value: values.rating,
              name: "rating",
              onChange: function onChange(event, newValue) {
                setFieldValue("rating", newValue);
              }
            }), errors.rating && touched.rating && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "invalid-feedback frontend",
              children: errors.rating
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "First Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  type: "text",
                  placeholder: "First Name",
                  onChange: function onChange(e) {
                    setFieldValue("reviewerName", e.target.value);
                  },
                  value: values.reviewerName
                })]
              }), errors.reviewerName && touched.reviewerName && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerName
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Last Name"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  onChange: function onChange(e) {
                    setLastName(e.target.value);
                  },
                  type: "text",
                  placeholder: "Last Name"
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Email Address"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("input", {
                  type: "text",
                  placeholder: "Email Address",
                  name: "reviewerEmail",
                  onChange: function onChange(e) {
                    setFieldValue("reviewerEmail", e.target.value);
                  },
                  value: values.reviewerEmail
                })]
              }), errors.reviewerEmail && touched.reviewerEmail && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerEmail
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 6,
              sm: 12,
              xs: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Phone Number"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)((react_phone_input_2__WEBPACK_IMPORTED_MODULE_8___default()), {
                  placeholder: "Phone Number",
                  country: defaultCountryCode !== null && defaultCountryCode !== void 0 ? defaultCountryCode : "in",
                  countryCodeEditable: false,
                  value: values.phone,
                  onChange: function onChange(_value, country, _event, formattedValue) {
                    setFieldValue("reviewerPhone", formattedValue);
                  },
                  className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().phoneInput)
                })]
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Country"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                  id: "reviewerCountryId",
                  name: "reviewerCountryId",
                  placeholder: "Select Your Country",
                  options: countryList !== null && countryList !== void 0 ? countryList : [],
                  multi: false,
                  styles: customStyles,
                  onChange: function onChange(item) {
                    setFieldValue("reviewerCountryId", item.value);
                  },
                  value: countryList ? countryList.filter(function (item) {
                    return item.value == (values === null || values === void 0 ? void 0 : values.reviewerCountryId);
                  }) : {}
                })]
              }), errors.reviewerCountryId && touched.reviewerCountryId && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewerCountryId
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              md: 12,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().text_input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("label", {
                  children: "Write Your Review"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("textarea", {
                  style: {
                    resize: "vertical"
                  },
                  name: "reviewComment",
                  onChange: function onChange(e) {
                    setFieldValue("reviewComment", e.target.value);
                  },
                  value: values.reviewComment,
                  type: "text",
                  placeholder: "Write Here"
                })]
              }), errors.reviewComment && touched.reviewComment && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewComment
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
              item: true,
              sm: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_12___default().action_btn),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("button", {
                  onClick: function onClick() {
                    return handleSubmit;
                  },
                  type: "submit",
                  className: "btn btn-secondary btn-md",
                  children: "Submit Review"
                })
              })
            })]
          })]
        });
      }
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (GuestFormReview);

/***/ }),

/***/ 25702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(90926);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(79072);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85014);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82580);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74231);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88740);
/* harmony import */ var _guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72145);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2804);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89093);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8612);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);



/* eslint-disable react-hooks/exhaustive-deps */















var init = {
  universityId: undefined,
  rating: undefined,
  reviewerType: "registered",
  reviewComment: ""
};

var RegisterFormReview = function RegisterFormReview(_ref) {
  var uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      onEdit = _ref.onEdit,
      existingComment = _ref.existingComment,
      getComment = _ref.getComment;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)();
  var asPath = router.asPath;
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_6__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_7__/* .authAtom */ .L4);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(init),
      formData = _useState[0],
      setFormData = _useState[1];

  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_9__/* .useSystemActions */ .x3)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (onEdit) {
      setFormData({
        universityId: parseInt(existingComment === null || existingComment === void 0 ? void 0 : existingComment.universityId),
        rating: parseInt(existingComment === null || existingComment === void 0 ? void 0 : existingComment.rating),
        reviewerType: "registered",
        reviewComment: existingComment === null || existingComment === void 0 ? void 0 : existingComment.reviewComment
      });
    } else {
      setFormData(init);
    }
  }, [onEdit, existingComment]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    systemActions.removeReturnUrl();
  }, []); // validation schema

  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_4__/* .object */ .Ry().shape({
    rating: yup__WEBPACK_IMPORTED_MODULE_4__/* .number */ .Rx().required("Field is required"),
    reviewComment: yup__WEBPACK_IMPORTED_MODULE_4__/* .string */ .Z_().required("Field is required")
  });

  var handleSubmitForm = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(values) {
      var payload;
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              payload = {
                universityId: uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universityId,
                rating: values.rating,
                reviewerType: "registered",
                reviewerId: profileInfo.id,
                reviewComment: values.reviewComment // reviewerName: `${profileInfo.firstName} ${profileInfo.middleName} ${profileInfo.lastName}`,
                // reviewerEmail: profileInfo.email,
                // reviewerPhone: profileInfo.mobile,
                // reviewerCountryId: profileInfo.countryId,

              };

              if (!onEdit) {
                _context3.next = 6;
                break;
              }

              _context3.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].patch */ .Z.patch("/public/university-review/".concat(existingComment === null || existingComment === void 0 ? void 0 : existingComment.universityReviewId), payload).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (res.error) {
                            _context.next = 8;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__/* .swalSuccess */ .Xt)("Updated");
                          setModal(false);
                          _context.next = 5;
                          return getData();

                        case 5:
                          _context.next = 7;
                          return getComment();

                        case 7:
                          router.push(asPath);

                        case 8:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 4:
              _context3.next = 8;
              break;

            case 6:
              _context3.next = 8;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("/public/university-review", payload).then( /*#__PURE__*/function () {
                var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (res.error) {
                            _context2.next = 7;
                            break;
                          }

                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_5__/* .swalSuccess */ .Xt)("Submitted");
                          setModal(false);
                          _context2.next = 5;
                          return getData();

                        case 5:
                          _context2.next = 7;
                          return getComment();

                        case 7:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmitForm(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var getSign = /*#__PURE__*/function () {
    var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              systemActions.setReturnUrl(router.asPath);
              _context4.next = 3;
              return router.push({
                pathname: "/signin"
              });

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getSign() {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
    className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().wrapper),
    children: profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Formik */ .J9, {
      initialValues: formData,
      enableReinitialize: true,
      validationSchema: validationSchema,
      onSubmit: function onSubmit(values) {
        handleSubmitForm(values);
      },
      children: function children(_ref6) {
        var handleSubmit = _ref6.handleSubmit,
            setFieldValue = _ref6.setFieldValue,
            values = _ref6.values,
            errors = _ref6.errors,
            touched = _ref6.touched;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(formik__WEBPACK_IMPORTED_MODULE_3__/* .Form */ .l0, {
          className: "form",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
            className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().rating_wrapper),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
              sx: {
                fontSize: "50px",
                mt: 3
              },
              value: parseInt(values.rating),
              name: "rating",
              onChange: function onChange(event, newValue) {
                setFieldValue("rating", newValue);
              }
            }), errors.rating && touched.rating && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
              className: "invalid-feedback frontend",
              children: errors.rating
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
            container: true,
            spacing: 4,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
              item: true,
              md: 12,
              sm: 12,
              xs: 12,
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().text_input_wrapper),
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("label", {
                  children: "Write your review"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("textarea", {
                  style: {
                    resize: "vertical"
                  },
                  name: "reviewComment",
                  onChange: function onChange(e) {
                    setFieldValue("reviewComment", e.target.value);
                  },
                  value: values.reviewComment,
                  type: "text",
                  placeholder: "Write Here"
                })]
              }), errors.reviewComment && touched.reviewComment && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                className: "invalid-feedback frontend",
                children: errors.reviewComment
              })]
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
              item: true,
              sm: 12,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: (_guest_form_review_module_scss__WEBPACK_IMPORTED_MODULE_13___default().action_btn),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                  onClick: function onClick() {
                    return handleSubmit;
                  },
                  type: "submit",
                  className: "btn btn-secondary btn-md",
                  children: onEdit ? "Update Review" : "Submit Review"
                })
              })
            })]
          })]
        });
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
      style: {
        width: "100%",
        marginTop: "20px"
      },
      onClick: getSign,
      className: "btn btn-secondary btn-bg",
      children: "Sign in"
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RegisterFormReview);

/***/ }),

/***/ 41328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _university_name_; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_modules/study/common/index.js + 3 modules
var common = __webpack_require__(69421);
// EXTERNAL MODULE: ./_modules/study/country/study_overview/index.js + 4 modules
var study_overview = __webpack_require__(7311);
// EXTERNAL MODULE: ./_modules/study/university/index.js + 4 modules
var university = __webpack_require__(97623);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/guest_form_review.jsx
var guest_form_review = __webpack_require__(17171);
// EXTERNAL MODULE: ./_modules/study/university/uni_reviews/components/register_form_review.jsx
var register_form_review = __webpack_require__(25702);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Modal/Modal.js + 2 modules
var Modal = __webpack_require__(15825);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(58735);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_recoil/_state/index.js + 9 modules
var _state = __webpack_require__(89093);
// EXTERNAL MODULE: ./node_modules/recoil/es/recoil.js
var recoil = __webpack_require__(2804);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_modules/study/university/components/uni_thumb_grid_box/uni_review_box/uni_review_box.module.scss
var uni_review_box_module = __webpack_require__(93979);
var uni_review_box_module_default = /*#__PURE__*/__webpack_require__.n(uni_review_box_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_modules/study/university/components/uni_thumb_grid_box/uni_review_box/uni_review_box.jsx
















var ReviewOption = function ReviewOption(_ref) {
  var value = _ref.value,
      uniProfileData = _ref.uniProfileData,
      setModal = _ref.setModal,
      getData = _ref.getData,
      existingComment = _ref.existingComment,
      onEdit = _ref.onEdit,
      getComment = _ref.getComment;

  switch (value) {
    case 0:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(guest_form_review/* default */.Z, {
        getData: getData,
        setModal: setModal,
        uniProfileData: uniProfileData
      });

    case 1:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(register_form_review/* default */.Z, {
        setModal: setModal,
        uniProfileData: uniProfileData,
        getData: getData,
        onEdit: onEdit,
        existingComment: existingComment,
        getComment: getComment
      });
  }
};

var UniReviewBox = function UniReviewBox(_ref2) {
  var uniProfileData = _ref2.uniProfileData;
  var profileInfo = (0,recoil/* useRecoilValue */.sJ)(_state/* authAtom */.L4);

  var _useState = (0,react.useState)(false),
      modal = _useState[0],
      setModal = _useState[1];

  var _useState2 = (0,react.useState)(0),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,react.useState)({}),
      existingComment = _useState3[0],
      setExistingComment = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      onEdit = _useState4[0],
      setOnEdit = _useState4[1]; // get existing comment


  var getComment = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return api/* default.get */.Z.get("/public/university-review/check/".concat(uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug)).then(function (res) {
                if (!res.error && res.data) {
                  var data = res.data;
                  setExistingComment(data);
                  setOnEdit(true);
                } else {
                  setExistingComment({});
                  setOnEdit(false);
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getComment() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    if (uniProfileData !== null && uniProfileData !== void 0 && uniProfileData.universitySlug && profileInfo && modal) {
      getComment();
    }
  }, [uniProfileData === null || uniProfileData === void 0 ? void 0 : uniProfileData.universitySlug, profileInfo, modal]);
  (0,react.useEffect)(function () {
    if (profileInfo) {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [profileInfo]);

  var getData = function getData() {};

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "container",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (uni_review_box_module_default()).wrapper,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        spacing: 4,
        alignItems: "center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          md: 6,
          sm: 12,
          xs: 12,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_review_box_module_default()).left_wrapper,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
              className: (uni_review_box_module_default()).heading,
              children: "Review This University!"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (uni_review_box_module_default()).description,
              children: "Are you a student or alumnus of this university? Share your review with prospective students."
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
          item: true,
          md: 6,
          sm: 12,
          xs: 12,
          sx: {
            display: "flex",
            justifyContent: "end"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (uni_review_box_module_default()).right_wrapper,
            onClick: function onClick() {
              setModal(true);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (uni_review_box_module_default()).img_wrapper,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: (0,helpers/* getAssets */.Vh)("assets/five_star.png"),
                alt: "five_star"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (uni_review_box_module_default()).action,
              children: "Rate this university"
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Modal/* default */.Z, {
      open: modal,
      onClose: function onClose() {
        setModal(false);
      },
      closeAfterTransition: true,
      BackdropComponent: Backdrop/* default */.Z,
      BackdropProps: {
        timeout: 500
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "modal md",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "modal_head ".concat((uni_review_box_module_default()).modal_header),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
            className: "".concat((uni_review_box_module_default()).title, " modal_title")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: "cross_icon ".concat((uni_review_box_module_default()).cross_action),
            onClick: function onClick() {
              setModal(false);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FiX */.q5L, {})
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "".concat((uni_review_box_module_default()).modal_body, " modal_body"),
          children: (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.userTypeSlug) == "university" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (uni_review_box_module_default()).modal_title,
              children: "Writing Review"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "center",
              children: "You can't give review yourself"
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              className: (uni_review_box_module_default()).modal_title,
              children: "Write a Review"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (uni_review_box_module_default()).modal_description,
              children: "Are you a current student or alumnus of this university? Let us know more about your experience, and what prospective international students can expect applying to and enrolling here!"
            }), !profileInfo && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: (uni_review_box_module_default()).action_btn,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  setValue(0);
                },
                className: value === 0 && (uni_review_box_module_default()).active_btn,
                children: "Guest User"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                onClick: function onClick() {
                  setValue(1);
                },
                className: value === 1 && (uni_review_box_module_default()).active_btn,
                children: "Registered User"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(ReviewOption, {
              setModal: setModal,
              uniProfileData: uniProfileData,
              value: value,
              getData: getData,
              existingComment: existingComment,
              onEdit: onEdit,
              getComment: getComment
            })]
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var uni_review_box = (UniReviewBox);
// EXTERNAL MODULE: ./_modules/study/university/uni_overview/index.js + 19 modules
var uni_overview = __webpack_require__(30851);
// EXTERNAL MODULE: ./_unisearch/theme/layout/index.js + 17 modules
var layout = __webpack_require__(81496);
;// CONCATENATED MODULE: ./pages/study/[country_name]/university/[university_name]/index.jsx











var UniversityOverview = function UniversityOverview(_ref) {
  var universityProfileData = _ref.universityProfileData,
      courseLevelData = _ref.courseLevelData,
      country_name = _ref.country_name,
      university_name = _ref.university_name,
      overviewText = _ref.overviewText;
  var levelCount = courseLevelData === null || courseLevelData === void 0 ? void 0 : courseLevelData.filter(function (item) {
    return item.totalCourse != 0 && item.totalCourse != null;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* LayoutMain */.Ku, {
    footer_with_evaluation: true,
    title: universityProfileData ? "".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " - Ranking, Fees, Scholarships Courses, Admissions") : "",
    metaDescription: overviewText ? (0,helpers/* excerpt */.X1)(overviewText, 500) : "".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.universityName, " - Ranking, Fees, Scholarships Courses, Admissions"),
    metaImage: (universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.featureSrc) || (universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.coverphotoLogoSrc),
    metaUrl: "".concat("https://myunisearch.com", "/study/").concat(country_name, "/university/").concat(university_name),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(university/* UniProfileWrapper */.au, {
        uniProfileData: universityProfileData,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview/* UniOverview */.LQ, {
          universityProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview/* UniOverviewAdmission */.RH, {
          universityProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview/* UniOverviewScholarship */.vV, {
          universityProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview/* UniOverviewCourses */.xA, {
          universityProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(uni_overview/* UniOverviewCampus */.fM, {
          universityProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(common/* ClientReview */.t5, {
          universityProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(uni_review_box, {
          uniProfileData: universityProfileData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(study_overview/* StudyOverviewTopRankTwo */.xH, {
          backgroundColor: "transparent",
          padding: "0",
          heading: "Popular Universities of ".concat(universityProfileData === null || universityProfileData === void 0 ? void 0 : universityProfileData.CountryName),
          subHeading: "Take a closer look at the universities, colleges, and institutes popular among international students across major study abroad destinations."
        })]
      })
    })
  });
};

var __N_SSP = true;
/* harmony default export */ var _university_name_ = (UniversityOverview);

/***/ }),

/***/ 72501:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/study/[country_name]/university/[university_name]",
      function () {
        return __webpack_require__(41328);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 81648:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"course_card":"course_card_course_card__AxRrI","course_card_title":"course_card_course_card_title__vg3Cj","course_card_info_lists":"course_card_course_card_info_lists__adoRI","course_card_icon":"course_card_course_card_icon__Q_A3H","course_card_text":"course_card_course_card_text__BKIGI","card_text_last":"course_card_card_text_last__Z9Fbt","course_card_link":"course_card_course_card_link__Wnw7V","more_intake_wrapper":"course_card_more_intake_wrapper__0gOlg","more_intake":"course_card_more_intake__yi0Bc","more_intake_num":"course_card_more_intake_num__pVWwv","align_row":"course_card_align_row__5bU4S"};

/***/ }),

/***/ 21003:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"scp_card":"scholarship_card_scp_card__m55BM","scp_card_tags":"scholarship_card_scp_card_tags__HeDat","exclusive":"scholarship_card_exclusive__2wuse","applicant":"scholarship_card_applicant__A0AtT","scp_card_title":"scholarship_card_scp_card_title__YNsEQ","scp_card_info_lists":"scholarship_card_scp_card_info_lists__dmmND","scp_card_icon":"scholarship_card_scp_card_icon__GXlqL","scp_card_text":"scholarship_card_scp_card_text__8MbPS","scp_card_link":"scholarship_card_scp_card_link__GRySi"};

/***/ }),

/***/ 93979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uni_review_box_wrapper__y10JD","modal_header":"uni_review_box_modal_header__REFfR","left_wrapper":"uni_review_box_left_wrapper__QsR16","heading":"uni_review_box_heading__rD_ZY","description":"uni_review_box_description__3W6wr","right_wrapper":"uni_review_box_right_wrapper__rnoFA","img_wrapper":"uni_review_box_img_wrapper__ergwg","action":"uni_review_box_action__xvDwM","modal_body":"uni_review_box_modal_body__jbMnj","modal_title":"uni_review_box_modal_title__nq3t2","modal_description":"uni_review_box_modal_description__yc0i5","action_btn":"uni_review_box_action_btn__vUX2w","active_btn":"uni_review_box_active_btn__BfCqt"};

/***/ }),

/***/ 47022:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_uni_brief":"uni_brief_section_uni_brief__HDqFd","brief_wrapper":"uni_brief_brief_wrapper__L8JIS","brief_left_wrapper":"uni_brief_brief_left_wrapper__LVU6c","uni_logo_wrapper":"uni_brief_uni_logo_wrapper__GRSAp","uni_brief_info":"uni_brief_uni_brief_info__K7_DQ","brief_right_wrapper":"uni_brief_brief_right_wrapper__SV0_H","info_rating_stars":"uni_brief_info_rating_stars__kasMS","info_rating_number":"uni_brief_info_rating_number__QLgq6","uni_web_link":"uni_brief_uni_web_link__KgEaj","compare_wrapper":"uni_brief_compare_wrapper__qDVt3","icon_heart":"uni_brief_icon_heart__kAVta","icon_swap":"uni_brief_icon_swap__MeiHF","rating_wrapper":"uni_brief_rating_wrapper__xFFKY","modal_header":"uni_brief_modal_header__NDrGT","modal_body":"uni_brief_modal_body__lfBwt","modal_title":"uni_brief_modal_title__E8rR7","modal_description":"uni_brief_modal_description__yvCMC","action_btn":"uni_brief_action_btn__yH_0f","active_btn":"uni_brief_active_btn__VgSdv"};

/***/ }),

/***/ 47656:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uni_hero":"uni_hero_with_video_uni_hero__EYNPe","video_wrapper":"uni_hero_with_video_video_wrapper__zyLOm","overlay":"uni_hero_with_video_overlay__H6twK"};

/***/ }),

/***/ 13777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_links___next__muTBt","section_links":"uni_links_section_links__xN6Wg","links_wrapper":"uni_links_links_wrapper__VqfJE","links_container":"uni_links_links_container__y3gQ7","link_lists":"uni_links_link_lists__aXFrS","link_list_item":"uni_links_link_list_item__1VTz2","active":"uni_links_active__w_Jji","currencyChanger":"uni_links_currencyChanger__AAlM8"};

/***/ }),

/***/ 1288:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_overview":"uni_overview_section_overview__mGpZG","uni_overview_sec_wrapper":"uni_overview_uni_overview_sec_wrapper__QgX2y","highlights":"uni_overview_highlights__Cqzjo","uni_ata_glance_list":"uni_overview_uni_ata_glance_list__OUGSF","uni_list_name":"uni_overview_uni_list_name__YMDDf","uni_list_ratio":"uni_overview_uni_list_ratio__A3Gha","overview":"uni_overview_overview__NTDpP"};

/***/ }),

/***/ 28019:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_accomodation":"uni_overview_accomodation_section_accomodation__VDNAB","title_wrapper":"uni_overview_accomodation_title_wrapper__I1rfH","acc_heading":"uni_overview_accomodation_acc_heading___v3L8","acc_desc_title":"uni_overview_accomodation_acc_desc_title__VQONA","acc_desc":"uni_overview_accomodation_acc_desc__DG87G","image_wrapper":"uni_overview_accomodation_image_wrapper__qTjef","image_shadow":"uni_overview_accomodation_image_shadow__eTDab","image_ornament":"uni_overview_accomodation_image_ornament__oIRrL"};

/***/ }),

/***/ 96868:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"uni_overview_admission_title_wrapper__1Es_Y","table_wrapper":"uni_overview_admission_table_wrapper__RYJew","content_wrapper":"uni_overview_admission_content_wrapper__Ft5Ig","image_wrapper":"uni_overview_admission_image_wrapper__Py6GK","image_university":"uni_overview_admission_image_university__SDlCy","image_shadow":"uni_overview_admission_image_shadow__HBW_b","image_ornament":"uni_overview_admission_image_ornament__9mPuC","image_money":"uni_overview_admission_image_money__zdJpC","admission":"uni_overview_admission_admission__wowZV","admission_requirement_table_wrapper":"uni_overview_admission_admission_requirement_table_wrapper__P0Ojj","coursesList":"uni_overview_admission_coursesList__7wU4b","courseLevelName":"uni_overview_admission_courseLevelName__NGspQ","course_list_course_link":"uni_overview_admission_course_list_course_link__yPMhL"};

/***/ }),

/***/ 79675:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"uni_overview_campus_title_wrapper__UYZCc","campus_address_wrapper":"uni_overview_campus_campus_address_wrapper__XCYyw","campus_address_title":"uni_overview_campus_campus_address_title__YGu5e","campuses_wrapper":"uni_overview_campus_campuses_wrapper__AjRRs","tabs_wrapper":"uni_overview_campus_tabs_wrapper__1lT4q","map_wrapper":"uni_overview_campus_map_wrapper__s8K8c","address":"uni_overview_campus_address__5J7QJ"};

/***/ }),

/***/ 82334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section_courses":"uni_overview_courses_section_courses__b3786","title_wrapper":"uni_overview_courses_title_wrapper__28PJs","btn_wrapper":"uni_overview_courses_btn_wrapper__anOj0"};

/***/ }),

/***/ 54729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title_wrapper":"uni_overview_scholarship_title_wrapper__Yr6nY"};

/***/ }),

/***/ 98576:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"__next":"uni_profile_banner___next__ExBkw","section_banner":"uni_profile_banner_section_banner__7vgrZ","banner_wrapper":"uni_profile_banner_banner_wrapper__widLd","banner_image":"uni_profile_banner_banner_image__R_T_c"};

/***/ }),

/***/ 98281:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"uni_profile_wrapper_root__IDxrR","uni_breacrumbs":"uni_profile_wrapper_uni_breacrumbs__jGbp2"};

/***/ }),

/***/ 88740:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guest_form_review_wrapper__u7nu7","rating_wrapper":"guest_form_review_rating_wrapper__I5gca","input_wrapper":"guest_form_review_input_wrapper__Y_rPr","text_input_wrapper":"guest_form_review_text_input_wrapper__3sak2","action_btn":"guest_form_review_action_btn__C_nI2","phoneInput":"guest_form_review_phoneInput__ui0mH"};

/***/ }),

/***/ 48318:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 86529:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(55541);


/***/ }),

/***/ 10753:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var React=__webpack_require__(67294),LeftArrow=function(_a){var customLeftArrow=_a.customLeftArrow,getState=_a.getState,previous=_a.previous,disabled=_a.disabled,rtl=_a.rtl;if(customLeftArrow)return React.cloneElement(customLeftArrow,{onClick:function(){return previous()},carouselState:getState(),disabled:disabled,rtl:rtl});var rtlClassName=rtl?"rtl":"";return React.createElement("button",{"aria-label":"Go to previous slide",className:"react-multiple-carousel__arrow react-multiple-carousel__arrow--left "+rtlClassName,onClick:function(){return previous()},type:"button",disabled:disabled})};exports.LeftArrow=LeftArrow;var RightArrow=function(_a){var customRightArrow=_a.customRightArrow,getState=_a.getState,next=_a.next,disabled=_a.disabled,rtl=_a.rtl;if(customRightArrow)return React.cloneElement(customRightArrow,{onClick:function(){return next()},carouselState:getState(),disabled:disabled,rtl:rtl});var rtlClassName=rtl?"rtl":"";return React.createElement("button",{"aria-label":"Go to next slide",className:"react-multiple-carousel__arrow react-multiple-carousel__arrow--right "+rtlClassName,onClick:function(){return next()},type:"button",disabled:disabled})};exports.RightArrow=RightArrow;

/***/ }),

/***/ 78365:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __extends=this&&this.__extends||function(){var extendStatics=function(d,b){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b}||function(d,b){for(var p in b)b.hasOwnProperty(p)&&(d[p]=b[p])})(d,b)};return function(d,b){function __(){this.constructor=d}extendStatics(d,b),d.prototype=null===b?Object.create(b):(__.prototype=b.prototype,new __)}}();Object.defineProperty(exports, "__esModule", ({value:!0}));var React=__webpack_require__(67294),utils_1=__webpack_require__(48035),types_1=__webpack_require__(45798),Dots_1=__webpack_require__(94851),Arrows_1=__webpack_require__(10753),CarouselItems_1=__webpack_require__(99946),common_1=__webpack_require__(13989),defaultTransitionDuration=400,defaultTransition="transform 400ms ease-in-out",Carousel=function(_super){function Carousel(props){var _this=_super.call(this,props)||this;return _this.containerRef=React.createRef(),_this.listRef=React.createRef(),_this.state={itemWidth:0,slidesToShow:0,currentSlide:0,totalItems:React.Children.count(props.children),deviceType:"",domLoaded:!1,transform:0,containerWidth:0},_this.onResize=_this.onResize.bind(_this),_this.handleDown=_this.handleDown.bind(_this),_this.handleMove=_this.handleMove.bind(_this),_this.handleOut=_this.handleOut.bind(_this),_this.onKeyUp=_this.onKeyUp.bind(_this),_this.handleEnter=_this.handleEnter.bind(_this),_this.setIsInThrottle=_this.setIsInThrottle.bind(_this),_this.next=utils_1.throttle(_this.next.bind(_this),props.transitionDuration||defaultTransitionDuration,_this.setIsInThrottle),_this.previous=utils_1.throttle(_this.previous.bind(_this),props.transitionDuration||defaultTransitionDuration,_this.setIsInThrottle),_this.goToSlide=utils_1.throttle(_this.goToSlide.bind(_this),props.transitionDuration||defaultTransitionDuration,_this.setIsInThrottle),_this.onMove=!1,_this.initialX=0,_this.lastX=0,_this.isAnimationAllowed=!1,_this.direction="",_this.initialY=0,_this.isInThrottle=!1,_this.transformPlaceHolder=0,_this}return __extends(Carousel,_super),Carousel.prototype.resetTotalItems=function(){var _this=this,totalItems=React.Children.count(this.props.children),currentSlide=utils_1.notEnoughChildren(this.state)?0:Math.max(0,Math.min(this.state.currentSlide,totalItems));this.setState({totalItems:totalItems,currentSlide:currentSlide},function(){_this.setContainerAndItemWidth(_this.state.slidesToShow,!0)})},Carousel.prototype.setIsInThrottle=function(isInThrottle){void 0===isInThrottle&&(isInThrottle=!1),this.isInThrottle=isInThrottle},Carousel.prototype.setTransformDirectly=function(position,withAnimation){var additionalTransfrom=this.props.additionalTransfrom;this.transformPlaceHolder=position;var currentTransform=common_1.getTransform(this.state,this.props,this.transformPlaceHolder);this.listRef&&this.listRef.current&&(this.setAnimationDirectly(withAnimation),this.listRef.current.style.transform="translate3d("+(currentTransform+additionalTransfrom)+"px,0,0)")},Carousel.prototype.setAnimationDirectly=function(animationAllowed){this.listRef&&this.listRef.current&&(this.listRef.current.style.transition=animationAllowed?this.props.customTransition||defaultTransition:"none")},Carousel.prototype.componentDidMount=function(){this.setState({domLoaded:!0}),this.setItemsToShow(),window.addEventListener("resize",this.onResize),this.onResize(!0),this.props.keyBoardControl&&window.addEventListener("keyup",this.onKeyUp),this.props.autoPlay&&(this.autoPlay=setInterval(this.next,this.props.autoPlaySpeed))},Carousel.prototype.setClones=function(slidesToShow,itemWidth,forResizing,resetCurrentSlide){var _this=this;void 0===resetCurrentSlide&&(resetCurrentSlide=!1),this.isAnimationAllowed=!1;var childrenArr=React.Children.toArray(this.props.children),initialSlide=utils_1.getInitialSlideInInfiniteMode(slidesToShow||this.state.slidesToShow,childrenArr),clones=utils_1.getClones(this.state.slidesToShow,childrenArr),currentSlide=childrenArr.length<this.state.slidesToShow?0:this.state.currentSlide;this.setState({totalItems:clones.length,currentSlide:forResizing&&!resetCurrentSlide?currentSlide:initialSlide},function(){_this.correctItemsPosition(itemWidth||_this.state.itemWidth)})},Carousel.prototype.setItemsToShow=function(shouldCorrectItemPosition,resetCurrentSlide){var _this=this,responsive=this.props.responsive;Object.keys(responsive).forEach(function(item){var _a=responsive[item],breakpoint=_a.breakpoint,items=_a.items,max=breakpoint.max,min=breakpoint.min;window.innerWidth>=min&&window.innerWidth<=max&&(_this.setState({slidesToShow:items,deviceType:item}),_this.setContainerAndItemWidth(items,shouldCorrectItemPosition,resetCurrentSlide))})},Carousel.prototype.setContainerAndItemWidth=function(slidesToShow,shouldCorrectItemPosition,resetCurrentSlide){var _this=this;if(this.containerRef&&this.containerRef.current){var containerWidth=this.containerRef.current.offsetWidth,itemWidth_1=utils_1.getItemClientSideWidth(this.props,slidesToShow,containerWidth);this.setState({containerWidth:containerWidth,itemWidth:itemWidth_1},function(){_this.props.infinite&&_this.setClones(slidesToShow,itemWidth_1,shouldCorrectItemPosition,resetCurrentSlide)}),shouldCorrectItemPosition&&this.correctItemsPosition(itemWidth_1)}},Carousel.prototype.correctItemsPosition=function(itemWidth,isAnimationAllowed,setToDomDirectly){isAnimationAllowed&&(this.isAnimationAllowed=!0),!isAnimationAllowed&&this.isAnimationAllowed&&(this.isAnimationAllowed=!1);var nextTransform=this.state.totalItems<this.state.slidesToShow?0:-itemWidth*this.state.currentSlide;setToDomDirectly&&this.setTransformDirectly(nextTransform,!0),this.setState({transform:nextTransform})},Carousel.prototype.onResize=function(value){var shouldCorrectItemPosition;shouldCorrectItemPosition=!!this.props.infinite&&("boolean"!=typeof value||!value),this.setItemsToShow(shouldCorrectItemPosition)},Carousel.prototype.componentDidUpdate=function(_a,_b){var _this=this,keyBoardControl=_a.keyBoardControl,autoPlay=_a.autoPlay,children=_a.children,containerWidth=_b.containerWidth,domLoaded=_b.domLoaded,currentSlide=_b.currentSlide;if(this.containerRef&&this.containerRef.current&&this.containerRef.current.offsetWidth!==containerWidth&&(this.itemsToShowTimeout&&clearTimeout(this.itemsToShowTimeout),this.itemsToShowTimeout=setTimeout(function(){_this.setItemsToShow(!0)},this.props.transitionDuration||defaultTransitionDuration)),keyBoardControl&&!this.props.keyBoardControl&&window.removeEventListener("keyup",this.onKeyUp),!keyBoardControl&&this.props.keyBoardControl&&window.addEventListener("keyup",this.onKeyUp),autoPlay&&!this.props.autoPlay&&this.autoPlay&&(clearInterval(this.autoPlay),this.autoPlay=void 0),autoPlay||!this.props.autoPlay||this.autoPlay||(this.autoPlay=setInterval(this.next,this.props.autoPlaySpeed)),children.length!==this.props.children.length?setTimeout(function(){_this.props.infinite?_this.setClones(_this.state.slidesToShow,_this.state.itemWidth,!0,!0):_this.resetTotalItems()},this.props.transitionDuration||defaultTransitionDuration):this.props.infinite&&this.state.currentSlide!==currentSlide&&this.correctClonesPosition({domLoaded:domLoaded}),this.transformPlaceHolder!==this.state.transform&&(this.transformPlaceHolder=this.state.transform),this.props.autoPlay&&this.props.rewind&&!this.props.infinite&&utils_1.isInRightEnd(this.state)){var rewindBuffer=this.props.transitionDuration||defaultTransitionDuration;setTimeout(function(){_this.setIsInThrottle(!1),_this.resetAutoplayInterval(),_this.goToSlide(0,void 0,!!_this.props.rewindWithAnimation)},rewindBuffer+this.props.autoPlaySpeed)}},Carousel.prototype.correctClonesPosition=function(_a){var _this=this,domLoaded=_a.domLoaded,childrenArr=React.Children.toArray(this.props.children),_b=utils_1.checkClonesPosition(this.state,childrenArr,this.props),isReachingTheEnd=_b.isReachingTheEnd,isReachingTheStart=_b.isReachingTheStart,nextSlide=_b.nextSlide,nextPosition=_b.nextPosition;this.state.domLoaded&&domLoaded&&(isReachingTheEnd||isReachingTheStart)&&(this.isAnimationAllowed=!1,setTimeout(function(){_this.setState({transform:nextPosition,currentSlide:nextSlide})},this.props.transitionDuration||defaultTransitionDuration))},Carousel.prototype.next=function(slidesHavePassed){var _this=this;void 0===slidesHavePassed&&(slidesHavePassed=0);var _a=this.props,afterChange=_a.afterChange,beforeChange=_a.beforeChange;if(!utils_1.notEnoughChildren(this.state)){var _b=utils_1.populateNextSlides(this.state,this.props,slidesHavePassed),nextSlides=_b.nextSlides,nextPosition=_b.nextPosition,previousSlide=this.state.currentSlide;void 0!==nextSlides&&void 0!==nextPosition&&("function"==typeof beforeChange&&beforeChange(nextSlides,this.getState()),this.isAnimationAllowed=!0,this.props.shouldResetAutoplay&&this.resetAutoplayInterval(),this.setState({transform:nextPosition,currentSlide:nextSlides},function(){"function"==typeof afterChange&&setTimeout(function(){afterChange(previousSlide,_this.getState())},_this.props.transitionDuration||defaultTransitionDuration)}))}},Carousel.prototype.previous=function(slidesHavePassed){var _this=this;void 0===slidesHavePassed&&(slidesHavePassed=0);var _a=this.props,afterChange=_a.afterChange,beforeChange=_a.beforeChange;if(!utils_1.notEnoughChildren(this.state)){var _b=utils_1.populatePreviousSlides(this.state,this.props,slidesHavePassed),nextSlides=_b.nextSlides,nextPosition=_b.nextPosition;if(void 0!==nextSlides&&void 0!==nextPosition){var previousSlide=this.state.currentSlide;"function"==typeof beforeChange&&beforeChange(nextSlides,this.getState()),this.isAnimationAllowed=!0,this.props.shouldResetAutoplay&&this.resetAutoplayInterval(),this.setState({transform:nextPosition,currentSlide:nextSlides},function(){"function"==typeof afterChange&&setTimeout(function(){afterChange(previousSlide,_this.getState())},_this.props.transitionDuration||defaultTransitionDuration)})}}},Carousel.prototype.resetAutoplayInterval=function(){this.props.autoPlay&&(clearInterval(this.autoPlay),this.autoPlay=setInterval(this.next,this.props.autoPlaySpeed))},Carousel.prototype.componentWillUnmount=function(){window.removeEventListener("resize",this.onResize),this.props.keyBoardControl&&window.removeEventListener("keyup",this.onKeyUp),this.props.autoPlay&&this.autoPlay&&(clearInterval(this.autoPlay),this.autoPlay=void 0),this.itemsToShowTimeout&&clearTimeout(this.itemsToShowTimeout)},Carousel.prototype.resetMoveStatus=function(){this.onMove=!1,this.initialX=0,this.lastX=0,this.direction="",this.initialY=0},Carousel.prototype.getCords=function(_a){var clientX=_a.clientX,clientY=_a.clientY;return{clientX:common_1.parsePosition(this.props,clientX),clientY:common_1.parsePosition(this.props,clientY)}},Carousel.prototype.handleDown=function(e){if(!(!types_1.isMouseMoveEvent(e)&&!this.props.swipeable||types_1.isMouseMoveEvent(e)&&!this.props.draggable||this.isInThrottle)){var _a=this.getCords(types_1.isMouseMoveEvent(e)?e:e.touches[0]),clientX=_a.clientX,clientY=_a.clientY;this.onMove=!0,this.initialX=clientX,this.initialY=clientY,this.lastX=clientX,this.isAnimationAllowed=!1}},Carousel.prototype.handleMove=function(e){if(!(!types_1.isMouseMoveEvent(e)&&!this.props.swipeable||types_1.isMouseMoveEvent(e)&&!this.props.draggable||utils_1.notEnoughChildren(this.state))){var _a=this.getCords(types_1.isMouseMoveEvent(e)?e:e.touches[0]),clientX=_a.clientX,clientY=_a.clientY,diffX=this.initialX-clientX,diffY=this.initialY-clientY;if(this.onMove){if(!(Math.abs(diffX)>Math.abs(diffY)))return;var _b=utils_1.populateSlidesOnMouseTouchMove(this.state,this.props,this.initialX,this.lastX,clientX,this.transformPlaceHolder),direction=_b.direction,nextPosition=_b.nextPosition,canContinue=_b.canContinue;direction&&(this.direction=direction,canContinue&&void 0!==nextPosition&&this.setTransformDirectly(nextPosition)),this.lastX=clientX}}},Carousel.prototype.handleOut=function(e){this.props.autoPlay&&!this.autoPlay&&(this.autoPlay=setInterval(this.next,this.props.autoPlaySpeed));var shouldDisableOnMobile="touchend"===e.type&&!this.props.swipeable,shouldDisableOnDesktop=("mouseleave"===e.type||"mouseup"===e.type)&&!this.props.draggable;if(!shouldDisableOnMobile&&!shouldDisableOnDesktop&&this.onMove){if(this.setAnimationDirectly(!0),"right"===this.direction)if(this.initialX-this.lastX>=this.props.minimumTouchDrag){var slidesHavePassed=Math.round((this.initialX-this.lastX)/this.state.itemWidth);this.next(slidesHavePassed)}else this.correctItemsPosition(this.state.itemWidth,!0,!0);if("left"===this.direction)if(this.lastX-this.initialX>this.props.minimumTouchDrag){slidesHavePassed=Math.round((this.lastX-this.initialX)/this.state.itemWidth);this.previous(slidesHavePassed)}else this.correctItemsPosition(this.state.itemWidth,!0,!0);this.resetMoveStatus()}},Carousel.prototype.isInViewport=function(el){var _a=el.getBoundingClientRect(),_b=_a.top,top=void 0===_b?0:_b,_c=_a.left,left=void 0===_c?0:_c,_d=_a.bottom,bottom=void 0===_d?0:_d,_e=_a.right,right=void 0===_e?0:_e;return 0<=top&&0<=left&&bottom<=(window.innerHeight||document.documentElement.clientHeight)&&right<=(window.innerWidth||document.documentElement.clientWidth)},Carousel.prototype.isChildOfCarousel=function(el){return!!(el instanceof Element&&this.listRef&&this.listRef.current)&&this.listRef.current.contains(el)},Carousel.prototype.onKeyUp=function(e){var target=e.target;switch(e.keyCode){case 37:if(this.isChildOfCarousel(target))return this.previous();break;case 39:if(this.isChildOfCarousel(target))return this.next();break;case 9:if(this.isChildOfCarousel(target)&&target instanceof HTMLInputElement&&this.isInViewport(target))return this.next()}},Carousel.prototype.handleEnter=function(e){types_1.isMouseMoveEvent(e)&&this.autoPlay&&this.props.autoPlay&&this.props.pauseOnHover&&(clearInterval(this.autoPlay),this.autoPlay=void 0)},Carousel.prototype.goToSlide=function(slide,skipCallbacks,animationAllowed){var _this=this;if(void 0===animationAllowed&&(animationAllowed=!0),!this.isInThrottle){var itemWidth=this.state.itemWidth,_a=this.props,afterChange=_a.afterChange,beforeChange=_a.beforeChange,previousSlide=this.state.currentSlide;"function"!=typeof beforeChange||skipCallbacks&&("object"!=typeof skipCallbacks||skipCallbacks.skipBeforeChange)||beforeChange(slide,this.getState()),this.isAnimationAllowed=animationAllowed,this.props.shouldResetAutoplay&&this.resetAutoplayInterval(),this.setState({currentSlide:slide,transform:-itemWidth*slide},function(){_this.props.infinite&&_this.correctClonesPosition({domLoaded:!0}),"function"!=typeof afterChange||skipCallbacks&&("object"!=typeof skipCallbacks||skipCallbacks.skipAfterChange)||setTimeout(function(){afterChange(previousSlide,_this.getState())},_this.props.transitionDuration||defaultTransitionDuration)})}},Carousel.prototype.getState=function(){return this.state},Carousel.prototype.renderLeftArrow=function(disbaled){var _this=this,_a=this.props,customLeftArrow=_a.customLeftArrow,rtl=_a.rtl;return React.createElement(Arrows_1.LeftArrow,{customLeftArrow:customLeftArrow,getState:function(){return _this.getState()},previous:this.previous,disabled:disbaled,rtl:rtl})},Carousel.prototype.renderRightArrow=function(disbaled){var _this=this,_a=this.props,customRightArrow=_a.customRightArrow,rtl=_a.rtl;return React.createElement(Arrows_1.RightArrow,{customRightArrow:customRightArrow,getState:function(){return _this.getState()},next:this.next,disabled:disbaled,rtl:rtl})},Carousel.prototype.renderButtonGroups=function(){var _this=this,customButtonGroup=this.props.customButtonGroup;return customButtonGroup?React.cloneElement(customButtonGroup,{previous:function(){return _this.previous()},next:function(){return _this.next()},goToSlide:function(slideIndex,skipCallbacks){return _this.goToSlide(slideIndex,skipCallbacks)},carouselState:this.getState()}):null},Carousel.prototype.renderDotsList=function(){var _this=this;return React.createElement(Dots_1.default,{state:this.state,props:this.props,goToSlide:this.goToSlide,getState:function(){return _this.getState()}})},Carousel.prototype.renderCarouselItems=function(){var clones=[];if(this.props.infinite){var childrenArr=React.Children.toArray(this.props.children);clones=utils_1.getClones(this.state.slidesToShow,childrenArr)}return React.createElement(CarouselItems_1.default,{clones:clones,goToSlide:this.goToSlide,state:this.state,notEnoughChildren:utils_1.notEnoughChildren(this.state),props:this.props})},Carousel.prototype.render=function(){var _a=this.props,deviceType=_a.deviceType,arrows=_a.arrows,renderArrowsWhenDisabled=_a.renderArrowsWhenDisabled,removeArrowOnDeviceType=_a.removeArrowOnDeviceType,infinite=_a.infinite,containerClass=_a.containerClass,sliderClass=_a.sliderClass,customTransition=_a.customTransition,additionalTransfrom=_a.additionalTransfrom,renderDotsOutside=_a.renderDotsOutside,renderButtonGroupOutside=_a.renderButtonGroupOutside,className=_a.className,rtl=_a.rtl; false&&0;var _b=utils_1.getInitialState(this.state,this.props),shouldRenderOnSSR=_b.shouldRenderOnSSR,shouldRenderAtAll=_b.shouldRenderAtAll,isLeftEndReach=utils_1.isInLeftEnd(this.state),isRightEndReach=utils_1.isInRightEnd(this.state),shouldShowArrows=arrows&&!(removeArrowOnDeviceType&&(deviceType&&-1<removeArrowOnDeviceType.indexOf(deviceType)||this.state.deviceType&&-1<removeArrowOnDeviceType.indexOf(this.state.deviceType)))&&!utils_1.notEnoughChildren(this.state)&&shouldRenderAtAll,disableLeftArrow=!infinite&&isLeftEndReach,disableRightArrow=!infinite&&isRightEndReach,currentTransform=common_1.getTransform(this.state,this.props);return React.createElement(React.Fragment,null,React.createElement("div",{className:"react-multi-carousel-list "+containerClass+" "+className,dir:rtl?"rtl":"ltr",ref:this.containerRef},React.createElement("ul",{ref:this.listRef,className:"react-multi-carousel-track "+sliderClass,style:{transition:this.isAnimationAllowed?customTransition||defaultTransition:"none",overflow:shouldRenderOnSSR?"hidden":"unset",transform:"translate3d("+(currentTransform+additionalTransfrom)+"px,0,0)"},onMouseMove:this.handleMove,onMouseDown:this.handleDown,onMouseUp:this.handleOut,onMouseEnter:this.handleEnter,onMouseLeave:this.handleOut,onTouchStart:this.handleDown,onTouchMove:this.handleMove,onTouchEnd:this.handleOut},this.renderCarouselItems()),shouldShowArrows&&(!disableLeftArrow||renderArrowsWhenDisabled)&&this.renderLeftArrow(disableLeftArrow),shouldShowArrows&&(!disableRightArrow||renderArrowsWhenDisabled)&&this.renderRightArrow(disableRightArrow),shouldRenderAtAll&&!renderButtonGroupOutside&&this.renderButtonGroups(),shouldRenderAtAll&&!renderDotsOutside&&this.renderDotsList()),shouldRenderAtAll&&renderDotsOutside&&this.renderDotsList(),shouldRenderAtAll&&renderButtonGroupOutside&&this.renderButtonGroups())},Carousel.defaultProps={slidesToSlide:1,infinite:!1,draggable:!0,swipeable:!0,arrows:!0,renderArrowsWhenDisabled:!1,containerClass:"",sliderClass:"",itemClass:"",keyBoardControl:!0,autoPlaySpeed:3e3,showDots:!1,renderDotsOutside:!1,renderButtonGroupOutside:!1,minimumTouchDrag:80,className:"",dotListClass:"",focusOnSelect:!1,centerMode:!1,additionalTransfrom:0,pauseOnHover:!0,shouldResetAutoplay:!0,rewind:!1,rtl:!1,rewindWithAnimation:!1},Carousel}(React.Component);exports["default"]=Carousel;

/***/ }),

/***/ 99946:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var React=__webpack_require__(67294),utils_1=__webpack_require__(48035),CarouselItems=function(_a){var props=_a.props,state=_a.state,goToSlide=_a.goToSlide,clones=_a.clones,notEnoughChildren=_a.notEnoughChildren,itemWidth=state.itemWidth,children=props.children,infinite=props.infinite,itemClass=props.itemClass,itemAriaLabel=props.itemAriaLabel,partialVisbile=props.partialVisbile,partialVisible=props.partialVisible,_b=utils_1.getInitialState(state,props),flexBisis=_b.flexBisis,shouldRenderOnSSR=_b.shouldRenderOnSSR,domFullyLoaded=_b.domFullyLoaded,partialVisibilityGutter=_b.partialVisibilityGutter;return _b.shouldRenderAtAll?(partialVisbile&&console.warn('WARNING: Please correct props name: "partialVisible" as old typo will be removed in future versions!'),React.createElement(React.Fragment,null,(infinite?clones:React.Children.toArray(children)).map(function(child,index){return React.createElement("li",{key:index,"data-index":index,onClick:function(){props.focusOnSelect&&goToSlide(index)},"aria-hidden":utils_1.getIfSlideIsVisbile(index,state)?"false":"true","aria-label":itemAriaLabel||(child.props.ariaLabel?child.props.ariaLabel:null),style:{flex:shouldRenderOnSSR?"1 0 "+flexBisis+"%":"auto",position:"relative",width:domFullyLoaded?((partialVisbile||partialVisible)&&partialVisibilityGutter&&!notEnoughChildren?itemWidth-partialVisibilityGutter:itemWidth)+"px":"auto"},className:"react-multi-carousel-item "+(utils_1.getIfSlideIsVisbile(index,state)?"react-multi-carousel-item--active":"")+" "+itemClass},child)}))):null};exports["default"]=CarouselItems;

/***/ }),

/***/ 94851:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var React=__webpack_require__(67294),clones_1=__webpack_require__(53905),dots_1=__webpack_require__(4949),common_1=__webpack_require__(13989),Dots=function(_a){var props=_a.props,state=_a.state,goToSlide=_a.goToSlide,getState=_a.getState,showDots=props.showDots,customDot=props.customDot,dotListClass=props.dotListClass,infinite=props.infinite,children=props.children;if(!showDots||common_1.notEnoughChildren(state))return null;var numberOfDotsToShow,currentSlide=state.currentSlide,slidesToShow=state.slidesToShow,slidesToSlide=common_1.getSlidesToSlide(state,props),childrenArr=React.Children.toArray(children);numberOfDotsToShow=infinite?Math.ceil(childrenArr.length/slidesToSlide):Math.ceil((childrenArr.length-slidesToShow)/slidesToSlide)+1;var nextSlidesTable=dots_1.getLookupTableForNextSlides(numberOfDotsToShow,state,props,childrenArr),lookupTable=clones_1.getOriginalIndexLookupTableByClones(slidesToShow,childrenArr),currentSlides=lookupTable[currentSlide];return React.createElement("ul",{className:"react-multi-carousel-dot-list "+dotListClass},Array(numberOfDotsToShow).fill(0).map(function(_,index){var isActive,nextSlide;if(infinite){nextSlide=nextSlidesTable[index];var cloneIndex=lookupTable[nextSlide];isActive=currentSlides===cloneIndex||cloneIndex<=currentSlides&&currentSlides<cloneIndex+slidesToSlide}else{var maximumNextSlide=childrenArr.length-slidesToShow,possibileNextSlides=index*slidesToSlide;isActive=(nextSlide=maximumNextSlide<possibileNextSlides?maximumNextSlide:possibileNextSlides)===currentSlide||nextSlide<currentSlide&&currentSlide<nextSlide+slidesToSlide&&currentSlide<childrenArr.length-slidesToShow}return customDot?React.cloneElement(customDot,{index:index,active:isActive,key:index,onClick:function(){return goToSlide(nextSlide)},carouselState:getState()}):React.createElement("li",{"data-index":index,key:index,className:"react-multi-carousel-dot "+(isActive?"react-multi-carousel-dot--active":"")},React.createElement("button",{"aria-label":"Go to slide "+(index+1),onClick:function(){return goToSlide(nextSlide)}}))}))};exports["default"]=Dots;

/***/ }),

/***/ 55541:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0});var Carousel_1=__webpack_require__(78365);exports["default"]=Carousel_1.default;

/***/ }),

/***/ 45798:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __extends=this&&this.__extends||function(){var extendStatics=function(d,b){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(d,b){d.__proto__=b}||function(d,b){for(var p in b)b.hasOwnProperty(p)&&(d[p]=b[p])})(d,b)};return function(d,b){function __(){this.constructor=d}extendStatics(d,b),d.prototype=null===b?Object.create(b):(__.prototype=b.prototype,new __)}}();Object.defineProperty(exports, "__esModule", ({value:!0}));var React=__webpack_require__(67294);function isMouseMoveEvent(e){return"clientY"in e}exports.isMouseMoveEvent=isMouseMoveEvent;var Carousel=function(_super){function Carousel(){return null!==_super&&_super.apply(this,arguments)||this}return __extends(Carousel,_super),Carousel}(React.Component);exports["default"]=Carousel;

/***/ }),

/***/ 53905:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
function getOriginalCounterPart(index,_a,childrenArr){var slidesToShow=_a.slidesToShow,currentSlide=_a.currentSlide;return childrenArr.length>2*slidesToShow?index+2*slidesToShow:currentSlide>=childrenArr.length?childrenArr.length+index:index}function getOriginalIndexLookupTableByClones(slidesToShow,childrenArr){if(childrenArr.length>2*slidesToShow){for(var table={},firstBeginningOfClones=childrenArr.length-2*slidesToShow,firstEndOfClones=childrenArr.length-firstBeginningOfClones,firstCount=firstBeginningOfClones,i=0;i<firstEndOfClones;i++)table[i]=firstCount,firstCount++;var secondBeginningOfClones=childrenArr.length+firstEndOfClones,secondEndOfClones=secondBeginningOfClones+childrenArr.slice(0,2*slidesToShow).length,secondCount=0;for(i=secondBeginningOfClones;i<=secondEndOfClones;i++)table[i]=secondCount,secondCount++;var originalEnd=secondBeginningOfClones,originalCounter=0;for(i=firstEndOfClones;i<originalEnd;i++)table[i]=originalCounter,originalCounter++;return table}table={};var totalSlides=3*childrenArr.length,count=0;for(i=0;i<totalSlides;i++)table[i]=count,++count===childrenArr.length&&(count=0);return table}function getClones(slidesToShow,childrenArr){return childrenArr.length<slidesToShow?childrenArr:childrenArr.length>2*slidesToShow?childrenArr.slice(childrenArr.length-2*slidesToShow,childrenArr.length).concat(childrenArr,childrenArr.slice(0,2*slidesToShow)):childrenArr.concat(childrenArr,childrenArr)}function getInitialSlideInInfiniteMode(slidesToShow,childrenArr){return childrenArr.length>2*slidesToShow?2*slidesToShow:childrenArr.length}function checkClonesPosition(_a,childrenArr,props){var isReachingTheEnd,currentSlide=_a.currentSlide,slidesToShow=_a.slidesToShow,itemWidth=_a.itemWidth,totalItems=_a.totalItems,nextSlide=0,nextPosition=0,isReachingTheStart=0===currentSlide,originalFirstSlide=childrenArr.length-(childrenArr.length-2*slidesToShow);return childrenArr.length<slidesToShow?(nextPosition=nextSlide=0,isReachingTheStart=isReachingTheEnd=!1):childrenArr.length>2*slidesToShow?((isReachingTheEnd=currentSlide>=originalFirstSlide+childrenArr.length)&&(nextPosition=-itemWidth*(nextSlide=currentSlide-childrenArr.length)),isReachingTheStart&&(nextPosition=-itemWidth*(nextSlide=originalFirstSlide+(childrenArr.length-2*slidesToShow)))):((isReachingTheEnd=currentSlide>=2*childrenArr.length)&&(nextPosition=-itemWidth*(nextSlide=currentSlide-childrenArr.length)),isReachingTheStart&&(nextPosition=props.showDots?-itemWidth*(nextSlide=childrenArr.length):-itemWidth*(nextSlide=totalItems/3))),{isReachingTheEnd:isReachingTheEnd,isReachingTheStart:isReachingTheStart,nextSlide:nextSlide,nextPosition:nextPosition}}Object.defineProperty(exports, "__esModule", ({value:!0})),exports.getOriginalCounterPart=getOriginalCounterPart,exports.getOriginalIndexLookupTableByClones=getOriginalIndexLookupTableByClones,exports.getClones=getClones,exports.getInitialSlideInInfiniteMode=getInitialSlideInInfiniteMode,exports.checkClonesPosition=checkClonesPosition;

/***/ }),

/***/ 13989:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var elementWidth_1=__webpack_require__(16867);function notEnoughChildren(state){var slidesToShow=state.slidesToShow;return state.totalItems<slidesToShow}function getInitialState(state,props){var flexBisis,domLoaded=state.domLoaded,slidesToShow=state.slidesToShow,containerWidth=state.containerWidth,itemWidth=state.itemWidth,deviceType=props.deviceType,responsive=props.responsive,ssr=props.ssr,partialVisbile=props.partialVisbile,partialVisible=props.partialVisible,domFullyLoaded=Boolean(domLoaded&&slidesToShow&&containerWidth&&itemWidth);ssr&&deviceType&&!domFullyLoaded&&(flexBisis=elementWidth_1.getWidthFromDeviceType(deviceType,responsive));var shouldRenderOnSSR=Boolean(ssr&&deviceType&&!domFullyLoaded&&flexBisis);return{shouldRenderOnSSR:shouldRenderOnSSR,flexBisis:flexBisis,domFullyLoaded:domFullyLoaded,partialVisibilityGutter:elementWidth_1.getPartialVisibilityGutter(responsive,partialVisbile||partialVisible,deviceType,state.deviceType),shouldRenderAtAll:shouldRenderOnSSR||domFullyLoaded}}function getIfSlideIsVisbile(index,state){var currentSlide=state.currentSlide,slidesToShow=state.slidesToShow;return currentSlide<=index&&index<currentSlide+slidesToShow}function getTransformForCenterMode(state,props,transformPlaceHolder){var transform=transformPlaceHolder||state.transform;return!props.infinite&&0===state.currentSlide||notEnoughChildren(state)?transform:transform+state.itemWidth/2}function isInLeftEnd(_a){return!(0<_a.currentSlide)}function isInRightEnd(_a){var currentSlide=_a.currentSlide,totalItems=_a.totalItems;return!(currentSlide+_a.slidesToShow<totalItems)}function getTransformForPartialVsibile(state,partialVisibilityGutter,props,transformPlaceHolder){void 0===partialVisibilityGutter&&(partialVisibilityGutter=0);var currentSlide=state.currentSlide,slidesToShow=state.slidesToShow,isRightEndReach=isInRightEnd(state),shouldRemoveRightGutter=!props.infinite&&isRightEndReach,baseTransform=transformPlaceHolder||state.transform;if(notEnoughChildren(state))return baseTransform;var transform=baseTransform+currentSlide*partialVisibilityGutter;return shouldRemoveRightGutter?transform+(state.containerWidth-(state.itemWidth-partialVisibilityGutter)*slidesToShow):transform}function parsePosition(props,position){return props.rtl?-1*position:position}function getTransform(state,props,transformPlaceHolder){var partialVisbile=props.partialVisbile,partialVisible=props.partialVisible,responsive=props.responsive,deviceType=props.deviceType,centerMode=props.centerMode,transform=transformPlaceHolder||state.transform,partialVisibilityGutter=elementWidth_1.getPartialVisibilityGutter(responsive,partialVisbile||partialVisible,deviceType,state.deviceType);return parsePosition(props,partialVisible||partialVisbile?getTransformForPartialVsibile(state,partialVisibilityGutter,props,transformPlaceHolder):centerMode?getTransformForCenterMode(state,props,transformPlaceHolder):transform)}function getSlidesToSlide(state,props){var domLoaded=state.domLoaded,slidesToShow=state.slidesToShow,containerWidth=state.containerWidth,itemWidth=state.itemWidth,deviceType=props.deviceType,responsive=props.responsive,slidesToScroll=props.slidesToSlide||1,domFullyLoaded=Boolean(domLoaded&&slidesToShow&&containerWidth&&itemWidth);return props.ssr&&props.deviceType&&!domFullyLoaded&&Object.keys(responsive).forEach(function(device){var slidesToSlide=responsive[device].slidesToSlide;deviceType===device&&slidesToSlide&&(slidesToScroll=slidesToSlide)}),domFullyLoaded&&Object.keys(responsive).forEach(function(item){var _a=responsive[item],breakpoint=_a.breakpoint,slidesToSlide=_a.slidesToSlide,max=breakpoint.max,min=breakpoint.min;slidesToSlide&&window.innerWidth>=min&&window.innerWidth<=max&&(slidesToScroll=slidesToSlide)}),slidesToScroll}exports.notEnoughChildren=notEnoughChildren,exports.getInitialState=getInitialState,exports.getIfSlideIsVisbile=getIfSlideIsVisbile,exports.getTransformForCenterMode=getTransformForCenterMode,exports.isInLeftEnd=isInLeftEnd,exports.isInRightEnd=isInRightEnd,exports.getTransformForPartialVsibile=getTransformForPartialVsibile,exports.parsePosition=parsePosition,exports.getTransform=getTransform,exports.getSlidesToSlide=getSlidesToSlide;

/***/ }),

/***/ 4949:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var clones_1=__webpack_require__(53905),common_1=__webpack_require__(13989);function getLookupTableForNextSlides(numberOfDotsToShow,state,props,childrenArr){var table={},slidesToSlide=common_1.getSlidesToSlide(state,props);return Array(numberOfDotsToShow).fill(0).forEach(function(_,i){var nextSlide=clones_1.getOriginalCounterPart(i,state,childrenArr);if(0===i)table[0]=nextSlide;else{var now=table[i-1]+slidesToSlide;table[i]=now}}),table}exports.getLookupTableForNextSlides=getLookupTableForNextSlides;

/***/ }),

/***/ 16867:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var hasWarnAboutTypo=!1;function getPartialVisibilityGutter(responsive,partialVisible,serverSideDeviceType,clientSideDeviceType){var gutter=0,deviceType=clientSideDeviceType||serverSideDeviceType;return partialVisible&&deviceType&&(!hasWarnAboutTypo&&"production"!=="production"&&0&&(0),gutter=responsive[deviceType].partialVisibilityGutter||responsive[deviceType].paritialVisibilityGutter),gutter}function getWidthFromDeviceType(deviceType,responsive){var itemWidth;responsive[deviceType]&&(itemWidth=(100/responsive[deviceType].items).toFixed(1));return itemWidth}function getItemClientSideWidth(props,slidesToShow,containerWidth){return Math.round(containerWidth/(slidesToShow+(props.centerMode?1:0)))}exports.getPartialVisibilityGutter=getPartialVisibilityGutter,exports.getWidthFromDeviceType=getWidthFromDeviceType,exports.getItemClientSideWidth=getItemClientSideWidth;

/***/ }),

/***/ 48035:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var clones_1=__webpack_require__(53905);exports.getOriginalCounterPart=clones_1.getOriginalCounterPart,exports.getClones=clones_1.getClones,exports.checkClonesPosition=clones_1.checkClonesPosition,exports.getInitialSlideInInfiniteMode=clones_1.getInitialSlideInInfiniteMode;var elementWidth_1=__webpack_require__(16867);exports.getWidthFromDeviceType=elementWidth_1.getWidthFromDeviceType,exports.getPartialVisibilityGutter=elementWidth_1.getPartialVisibilityGutter,exports.getItemClientSideWidth=elementWidth_1.getItemClientSideWidth;var common_1=__webpack_require__(13989);exports.getInitialState=common_1.getInitialState,exports.getIfSlideIsVisbile=common_1.getIfSlideIsVisbile,exports.getTransformForCenterMode=common_1.getTransformForCenterMode,exports.getTransformForPartialVsibile=common_1.getTransformForPartialVsibile,exports.isInLeftEnd=common_1.isInLeftEnd,exports.isInRightEnd=common_1.isInRightEnd,exports.notEnoughChildren=common_1.notEnoughChildren,exports.getSlidesToSlide=common_1.getSlidesToSlide;var throttle_1=__webpack_require__(99950);exports.throttle=throttle_1.default;var throwError_1=__webpack_require__(34802);exports.throwError=throwError_1.default;var next_1=__webpack_require__(52558);exports.populateNextSlides=next_1.populateNextSlides;var previous_1=__webpack_require__(75210);exports.populatePreviousSlides=previous_1.populatePreviousSlides;var mouseOrTouchMove_1=__webpack_require__(91097);exports.populateSlidesOnMouseTouchMove=mouseOrTouchMove_1.populateSlidesOnMouseTouchMove;

/***/ }),

/***/ 91097:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
function populateSlidesOnMouseTouchMove(state,props,initialX,lastX,clientX,transformPlaceHolder){var direction,nextPosition,itemWidth=state.itemWidth,slidesToShow=state.slidesToShow,totalItems=state.totalItems,currentSlide=state.currentSlide,infinite=props.infinite,canContinue=!1,slidesHavePassedRight=Math.round((initialX-lastX)/itemWidth),slidesHavePassedLeft=Math.round((lastX-initialX)/itemWidth),isMovingLeft=initialX<clientX;if(clientX<initialX&&!!(slidesHavePassedRight<=slidesToShow)){direction="right";var translateXLimit=Math.abs(-itemWidth*(totalItems-slidesToShow)),nextTranslate=transformPlaceHolder-(lastX-clientX),isLastSlide=currentSlide===totalItems-slidesToShow;(Math.abs(nextTranslate)<=translateXLimit||isLastSlide&&infinite)&&(nextPosition=nextTranslate,canContinue=!0)}isMovingLeft&&slidesHavePassedLeft<=slidesToShow&&(direction="left",((nextTranslate=transformPlaceHolder+(clientX-lastX))<=0||0===currentSlide&&infinite)&&(canContinue=!0,nextPosition=nextTranslate));return{direction:direction,nextPosition:nextPosition,canContinue:canContinue}}Object.defineProperty(exports, "__esModule", ({value:!0})),exports.populateSlidesOnMouseTouchMove=populateSlidesOnMouseTouchMove;

/***/ }),

/***/ 52558:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var common_1=__webpack_require__(13989);function populateNextSlides(state,props,slidesHavePassed){void 0===slidesHavePassed&&(slidesHavePassed=0);var nextSlides,nextPosition,slidesToShow=state.slidesToShow,currentSlide=state.currentSlide,itemWidth=state.itemWidth,totalItems=state.totalItems,slidesToSlide=common_1.getSlidesToSlide(state,props),nextMaximumSlides=currentSlide+1+slidesHavePassed+slidesToShow+(0<slidesHavePassed?0:slidesToSlide);return nextPosition=nextMaximumSlides<=totalItems?-itemWidth*(nextSlides=currentSlide+slidesHavePassed+(0<slidesHavePassed?0:slidesToSlide)):totalItems<nextMaximumSlides&&currentSlide!==totalItems-slidesToShow?-itemWidth*(nextSlides=totalItems-slidesToShow):nextSlides=void 0,{nextSlides:nextSlides,nextPosition:nextPosition}}exports.populateNextSlides=populateNextSlides;

/***/ }),

/***/ 75210:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var React=__webpack_require__(67294),common_1=__webpack_require__(13989),common_2=__webpack_require__(13989);function populatePreviousSlides(state,props,slidesHavePassed){void 0===slidesHavePassed&&(slidesHavePassed=0);var nextSlides,nextPosition,currentSlide=state.currentSlide,itemWidth=state.itemWidth,slidesToShow=state.slidesToShow,children=props.children,showDots=props.showDots,infinite=props.infinite,slidesToSlide=common_1.getSlidesToSlide(state,props),nextMaximumSlides=currentSlide-slidesHavePassed-(0<slidesHavePassed?0:slidesToSlide),additionalSlides=(React.Children.toArray(children).length-slidesToShow)%slidesToSlide;return nextPosition=0<=nextMaximumSlides?(nextSlides=nextMaximumSlides,showDots&&!infinite&&0<additionalSlides&&common_2.isInRightEnd(state)&&(nextSlides=currentSlide-additionalSlides),-itemWidth*nextSlides):nextSlides=nextMaximumSlides<0&&0!==currentSlide?0:void 0,{nextSlides:nextSlides,nextPosition:nextPosition}}exports.populatePreviousSlides=populatePreviousSlides;

/***/ }),

/***/ 99950:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:!0}));var throttle=function(func,limit,setIsInThrottle){var inThrottle;return function(){var args=arguments;inThrottle||(func.apply(this,args),inThrottle=!0,"function"==typeof setIsInThrottle&&setIsInThrottle(!0),setTimeout(function(){inThrottle=!1,"function"==typeof setIsInThrottle&&setIsInThrottle(!1)},limit))}};exports["default"]=throttle;

/***/ }),

/***/ 34802:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
function throwError(state,props){var partialVisbile=props.partialVisbile,partialVisible=props.partialVisible,centerMode=props.centerMode,ssr=props.ssr,responsive=props.responsive;if((partialVisbile||partialVisible)&&centerMode)throw new Error("center mode can not be used at the same time with partialVisible");if(!responsive)throw ssr?new Error("ssr mode need to be used in conjunction with responsive prop"):new Error("Responsive prop is needed for deciding the amount of items to show on the screen");if(responsive&&"object"!=typeof responsive)throw new Error("responsive prop must be an object")}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=throwError;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,3609,260,1086,6158,2884,8719,8322,5824,3480,5551,5260,1818,926,3063,6066,6665,3023,6005,6673,1496,5603,9421,5477,9774,2888,179], function() { return __webpack_exec__(72501); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);